import { trackingMapCatalog } from './trackingMapCatalog.js';
import { maintenanceCatalog } from './maintenanceCatalog.js';

export const catalogs = {
  ro: {
    trackingMap: trackingMapCatalog.ro,
    maintenance: maintenanceCatalog.ro,
    common: {
      language: 'Limbă', retry: 'Reîncearcă', saving: 'Se salvează…',
      close: 'Închide', delete: 'Șterge', cancel: 'Anulează', save: 'Salvează', edit: 'Editează',
      reload: 'Reîncarcă', loading: 'Se încarcă...', error: 'Eroare', notifications: 'Notificări',
      profile: 'Profil', support: 'Suport', backToLogin: 'Înapoi la login',
      nameUnavailable: 'Nume indisponibil', nameNotSpecified: 'Nume nespecificat',
      notSpecified: 'Nespecificat', notAvailable: 'Nu este disponibil',
      languageChangeFailed: 'Limba nu a putut fi salvată. Selecția anterioară a fost restaurată.',
      calendar: {
        today: 'Astăzi', previousMonth: 'Luna anterioară', nextMonth: 'Luna următoare',
        chooseDate: 'Alege data',
        chooseMonth: 'Alege luna. Luna afișată este {{month}}.',
        chooseYear: 'Alege anul. Anul afișat este {{year}}.',
      },
      pagination: {
        resultsRange_one: 'Se afișează {{start}}–{{end}} din {{total}} rezultat',
        resultsRange_few: 'Se afișează {{start}}–{{end}} din {{total}} rezultate',
        resultsRange_other: 'Se afișează {{start}}–{{end}} din {{total}} de rezultate',
        noResults: 'Nu există rezultate', firstPage: 'Prima pagină',
        previousPage: 'Pagina anterioară', nextPage: 'Pagina următoare', lastPage: 'Ultima pagină',
        page: 'Pagina {{page}}', itemsPerPage: 'Elemente pe pagină:',
      },
      deleteConfirmation: {
        title: 'Confirmare ștergere',
        message: 'Sigur doriți să ștergeți acest element? Această acțiune nu poate fi anulată.',
        itemPrompt: 'Sigur doriți să ștergeți <item>„{{itemName}}”</item>?',
        irreversible: 'Această acțiune nu poate fi anulată.',
        confirm: 'Da, șterge',
      },
      home: { goToHome: 'Mergi la pagina principală' },
      tenantConfiguration: {
        title: 'Firma nu este configurată',
        description: 'Deschide aplicația folosind subdomeniul primit de la administratorul firmei.',
      },
      errorBoundary: {
        title: 'A apărut o problemă!',
        description: 'Ne pare rău, dar a avut loc o eroare neașteptată. Reîncărcați pagina.',
        reloadPage: 'Reîncarcă pagina',
      },
    },
    bootstrap: {
      loading: 'Se încarcă limbile disponibile…',
      failed: 'Nu am putut încărca limbile disponibile.',
    },
    tachograph: {
      csv: {
        date: 'Data', startTime: 'Ora început', endTime: 'Ora sfârșit',
        duration: 'Durată', activity: 'Activitate',
        optifleetFileName: 'raport-tahograf-optifleet-{{driverId}}-{{startDate}}-{{endDate}}.csv',
      },
      activities: {
        driving: 'Condus', rest: 'Odihnă', work: 'Alte activități',
        available: 'Disponibil', unknown: 'Necunoscut',
      },
    },
    transportDocuments: {
      title: 'Documente transport #{{transportId}}',
      available_one: '{{count}} document disponibil',
      available_few: '{{count}} documente disponibile',
      available_other: '{{count}} de documente disponibile',
      loading: 'Se încarcă documentele…',
      emptyTitle: 'Niciun document',
      emptyDescription: 'Nu există documente încărcate pentru acest transport.',
      view: 'Vezi',
      viewDocument: 'Vezi documentul',
      deleteDocument: 'Șterge documentul',
      confirmDelete: 'Sigur doriți să ștergeți acest document?',
      deleteSuccess: 'Document șters cu succes!',
      loadError: 'Eroare la încărcarea documentelor.',
      deleteError: 'Eroare la ștergerea documentului.',
      categories: {
        cmr: 'CMR (fotografie)',
        thermogram: 'Termodiagramă',
        deliveryNote: 'Aviz de însoțire a mărfii',
        invoice: 'Factură',
        customsDeclaration: 'Declarație vamală',
        certificateOfOrigin: 'Certificat de origine',
        loadingList: 'Listă de încărcare',
        adrDocuments: 'Documente ADR',
        otherDocuments: 'Alte documente',
      },
    },
    transportCard: {
      customerOrder: 'Comandă client',
    },
    transportCreation: {
      deliveryNotesSelected: '{{count}} avize selectate:',
      fromDeliveryNote: 'din aviz:',
      addedManually: 'adăugat manual',
      driverNumber: 'Șofer #{{id}}',
    },
    tripSheets: {
      viewer: {
        openingTitle: 'Se deschide foaia de parcurs…',
        preparing: 'Se pregătește documentul…',
      },
    },
    transportCrew: {
      driverNumber: 'Șofer #{{id}}',
      driverPosition: 'Șoferul {{position}}:',
      noDriver: 'Fără șofer',
      noDrivers: 'Fără șoferi',
    },
    cmrStatus: {
      statuses: {
        complete: { label: '✅ Complet', tooltip: 'Are atât CMR digital, cât și fizic' },
        digitalOnly: { label: '📝 Digital', tooltip: 'Are doar CMR digital completat' },
        physicalOnly: { label: '📄 Fizic', tooltip: 'Are doar CMR-uri fizice (scanate)' },
        none: { label: '❌ Lipsă', tooltip: 'Nu are niciun CMR' },
      },
      digitalProgress: 'Digital: {{value}}',
      physicalDocuments_one: 'Fizic: {{count}} document',
      physicalDocuments_few: 'Fizic: {{count}} documente',
      physicalDocuments_other: 'Fizic: {{count}} de documente',
    },
    profitability: {
      roundTrip: { at: 'la', by: 'de' },
      dispatcherProjection: {
        notice: 'Vizualizezi raportul tur-retur fără costurile de administrație. Cheltuielile și profitul sunt deja calculate astfel de server; nu se scade din nou administrația.',
        expensesLabel: 'Cheltuieli fără administrație',
        profitLabel: 'Profit fără administrație',
        allocatedExpenses: 'Cheltuieli alocate',
        completeTotals: 'Calcul final fără administrație pentru toate grupurile afișate.',
        transportNotice: 'Profitul afișat este al transportului fără administrație.',
        serverProjection: 'Valoarea este deja calculată de server fără costurile de administrație.',
      },
      currencyConversion: {
        ready: 'Cursurile de referință sunt disponibile. Schimbarea monedei convertește automat valoarea.',
        readyDated: 'Cursurile de referință pentru {{date}} sunt disponibile. Schimbarea monedei convertește automat valoarea.',
        loading: 'Se încarcă ultimele cursuri valutare disponibile…',
        loadError: 'Nu am putut încărca cursurile valutare. Conversia este blocată pentru a evita valori incorecte.',
        convertedFrom: 'Convertit din {{amount}}; schimbările ulterioare folosesc această valoare de bază.',
        conversionError: 'Suma nu a fost convertită deoarece lipsește cursul monedei inițiale. Corectează manual valoarea.',
      },
      pdf: {
        title: 'Raport profitabilitate tur-retur',
        truckFilter: 'Camion: {{value}}', driverFilter: 'Șofer: {{value}}',
        exportedGroups_one: '{{count}} grup exportat',
        exportedGroups_few: '{{count}} grupuri exportate',
        exportedGroups_other: '{{count}} de grupuri exportate',
        valuesInCurrency: 'valori în {{currency}}', generatedAt: 'Generat: {{value}}',
        columns: {
          period: 'Perioada', route: 'Traseu', truck: 'Camion', driver: 'Șofer',
          kilometres: 'Km', revenue: 'Venituri', fuel: 'Comb.', roadTolls: 'Taxe',
          perDiem: 'Diurnă', receipts: 'Bonuri', interventions: 'Interv.', other: 'Alte',
          groupSalary: 'Salariu grup', truckFixedCost: 'Fix camion',
          finalExpenses: 'Chelt. finale', finalProfit: 'Profit final',
        },
        summary: {
          revenue: 'Venituri', variableExpenses: 'Cheltuieli variabile',
          fixedCostsFullReportOnly: 'Costuri fixe (doar raport complet)',
          automaticFixedCosts: 'Costuri fixe automate',
          intermediateTripProfit: 'Profit curse (intermediar)',
          intermediateTableProfit: 'Profit tabel (intermediar)',
          finalCompanyNetProfit: 'Profit net final companie',
        },
        tableTotal: 'Total tabel', automaticReport: 'Atrux · Raport generat automat',
        page: 'Pagina {{page}}/{{totalPages}}',
        fileName: 'profitabilitate_tur_retur_{{month}}{{suffix}}.pdf',
      },
    },
    leaveReports: {
      generatedBy: 'Sistem de Management Concedii',
      annualPeriod: 'Anul {{year}}',
    },
    fileNames: {
      signedDocument: 'document-semnat-{{requestId}}.pdf',
      tripSheet: 'foaie_parcurs_{{date}}.pdf',
      cmrPhoto: 'Fotografie_CMR.jpg',
      optimizedRoute: 'ruta-optimizata-{{date}}.json',
      interventionsReport: 'raport_interventii_{{date}}.{{extension}}',
    },
    interventionReport: {
      title: 'Raport Intervenții',
      period: 'Perioadă: {{start}} — {{end}}',
      totalInterventions: 'Total intervenții: {{value}}',
      totalCost: 'Cost total: €{{value}}',
      topVehiclesByCost: 'Top vehicule după cost',
      interventions: 'Intervenții',
      columns: {
        vehicle: 'Vehicul',
        type: 'Tip',
        interventionCount: 'Nr. intervenții',
        totalCost: 'Cost total',
        reference: 'Referință',
        status: 'Status',
        entry: 'Intrare',
      },
      types: {
        preventiveMaintenance: 'Întreținere preventivă',
        repair: 'Reparație',
        periodicRevision: 'Revizie periodică',
        accident: 'Accident',
      },
      statuses: {
        scheduled: 'Programat',
        inProgress: 'În lucru',
        completed: 'Finalizat',
        cancelled: 'Anulat',
      },
      vehicleTypes: {
        truck: 'Camion',
        trailer: 'Remorcă',
        lightVehicle: 'Dubă',
      },
    },
    login: {
      welcome: 'Bine ai venit!', subtitle: 'Conectează-te pentru a continua!',
      phone: 'Număr de telefon', password: 'Parola', showPassword: 'Arată parola',
      hidePassword: 'Ascunde parola', submit: 'CONECTEAZĂ-TE', submitting: 'LOGARE',
      forgotPassword: 'Ai uitat parola? Resetează prin email', alternateAccess: 'Sau accesează ca:',
      expeditor: 'Sunt expeditor', recipient: 'Sunt destinatar', signer: 'Sunt semnatar general',
    },
    navigation: {
      dashboard: 'Dashboard', transports: 'Transporturi', liveTracking: 'Monitorizare GPS', drivers: 'Șoferi', trucks: 'Camioane',
      trailers: 'Remorci', cars: 'Autoturisme', vans: 'Dube', service: 'Service & Intervenții', maintenance: 'Mentenanță',
      cmr: 'Arhiva CMR-uri', uit: 'UIT e-Transport', freightBilling: 'Facturare expediții', billing: 'Facturare', profitability: 'Profitabilitate',
      profile: 'Profil', expiredDocuments: 'Acte expirate',
      notifications: 'Notificări', toggleMenu: 'Deschide sau închide meniul',
      collapseSidebar: 'Restrânge meniul lateral', expandSidebar: 'Extinde meniul lateral',
    },
    freightForwarding: {
      common: {
        transport: 'Transport', eligible: 'Eligibil', notEligible: 'Neeligibil',
        unknownAmount: 'Sumă necunoscută', requestError: 'Operațiunea nu a putut fi finalizată.', back: 'Înapoi',
      },
      dashboard: {
        ready: 'Gata de facturat', documentsOverdue: 'Documente restante', unpaid: 'Facturi neîncasate', activeFiles: 'Dosare active',
      },
      filters: {
        month: 'Luna livrării', customer: 'Client', carrier: 'Transportator', responsible: 'Responsabil',
        idPlaceholder: 'ID utilizator', searchPartner: 'Caută partenerul…', transportStatus: 'Stare transport', documentStatus: 'Stare documente', eligibility: 'Eligibilitate',
        documentsOverdue: 'Documente restante', unpaid: 'Neîncasat', minimumMargin: 'Marjă minimă',
        all: 'Toate', yes: 'Da', no: 'Nu', reset: 'Resetează', apply: 'Aplică filtrele',
      },
      queue: {
        eyebrow: 'Casă de expediție', title: 'Facturare transporturi',
        subtitle: 'Verifică dosarele și CMR-urile fizice, apoi emite individual sau grupează transporturi compatibile pe aceeași factură.',
        readOnlyTitle: 'Emiterea este indisponibilă.', readOnlyHint: 'Poți consulta și completa dosarele, însă emiterea necesită modulul e-Factura.',
        search: 'Caută după transport, client sau CUI…', filters: 'Filtre', loading: 'Se încarcă dosarele de facturare…',
        loadError: 'Lista transporturilor de facturat nu a putut fi încărcată.',
        emptyTitle: 'Nu există transporturi pentru această selecție', emptyHint: 'Schimbă filtrele sau verifică din nou după finalizarea unui transport.',
        customer: 'Client', amount: 'Valoare netă', documents: 'Dosar', payment: 'Încasare', eligibility: 'Facturare', actions: 'Acțiuni',
        physicalCmrs_one: '{{count}} CMR fizic', physicalCmrs_few: '{{count}} CMR-uri fizice', physicalCmrs_other: '{{count}} de CMR-uri fizice',
        openFile: 'Dosar', invoice: 'Facturează către client', notifyCustomer: 'Notifică clientul', selectAll: 'Selectează toate transporturile vizibile',
        carrierReference: 'Nr. transportator: {{reference}}',
        selectTransport: 'Selectează transportul {{number}}', selected_one: '{{count}} transport selectat',
        selected_few: '{{count}} transporturi selectate', selected_other: '{{count}} de transporturi selectate',
        selectionReady: 'Selecția este compatibilă pentru o factură comună.', clear: 'Șterge selecția',
        invoiceSelected: 'Facturează selecția', pageSummary: 'Pagina {{page}} din {{pages}} · {{count}} transporturi',
        directNotFound: 'Transportul nu se află pe pagina curentă a cozii. Folosește filtrele pentru a-l găsi.',
      },
      paymentNotice: {
        eyebrow: 'Notificare client', title: 'Trimite detaliile de plată',
        subtitle: 'Verifică mesajul pentru transportul {{number}} înainte de trimitere.',
        customer: 'Client', amount: 'Valoare', dueDate: 'Scadență', loading: 'Se încarcă datele comerciale ale clientului…',
        loadError: 'Datele de plată nu au putut fi încărcate complet. Poți completa mesajul manual.',
        email: 'Email client', missingEmail: 'Clientul nu are un email salvat. Completează adresa înainte de trimitere.',
        subject: 'Subiect', message: 'Mesaj', invalidEmail: 'Introdu o adresă de email validă.',
        requiredFields: 'Subiectul și mesajul sunt obligatorii.', send: 'Trimite notificarea', sending: 'Se trimite…',
        sent: 'Notificarea a fost trimisă către {{email}}.', sendError: 'Notificarea nu a putut fi trimisă.',
      },
      invoice: {
        eyebrow: 'Factură client', title_one: 'Facturează {{count}} transport', title_few: 'Facturează {{count}} transporturi', title_other: 'Facturează {{count}} de transporturi',
        subtitle: 'Flux ghidat: documentele clientului, date fiscale și confirmarea emiterii.', stepsLabel: 'Pașii facturării',
        stepDocuments: 'Documente', stepInvoice: 'Factura', stepProgress: 'Progres',
        incompatibleTitle: 'Selecția nu poate fi facturată integral', physicalCmrTitle: 'Confirmă CMR-urile fizice',
        physicalCmrHint: 'Selectează numai fotografiile sau scanurile CMR fizice acceptate. eCMR-ul generat nu le înlocuiește.',
        loadingDocuments: 'Se încarcă documentele transportului…', noPhysicalCmr: 'Nu există încă un CMR fizic în dosar.',
        selectPhysicalCmr: 'Selectează cel puțin un CMR fizic pentru acest transport.',
        fiscalData: 'Datele facturii', loadingFiscal: 'Se încarcă seriile și cotele TVA…', series: 'Serie',
        issueDate: 'Data emiterii', dueDate: 'Scadență', currency: 'Monedă', vat: 'Cotă TVA', description: 'Descriere serviciu',
        buyer: 'Date client', buyerName: 'Denumire', buyerCui: 'CUI', country: 'Țară', address: 'Adresă',
        sendEmail: 'Trimite factura clientului după emitere',
        sendEmailHint: 'Factura rămâne emisă chiar dacă emailul nu poate fi trimis. Trimiterea nu așteaptă acceptarea SPV.',
        recipient: 'Destinatar', emailLanguage: 'Limba emailului', subject: 'Subiect', message: 'Mesaj',
        defaultLine: 'Servicii transport', defaultSubject: 'Factura transport', defaultBody: 'Am atașat factura și CMR-ul aferent transportului.',
        validation: {
          series: 'Selectează seria de facturare.', issueDate: 'Alege data emiterii.', buyer: 'Completează denumirea, țara și adresa clientului.',
          vat: 'Selectează cota TVA.', amount: 'Fiecare transport trebuie să aibă o valoare netă pozitivă.', email: 'Introdu o adresă de email validă.',
        },
        efacturaRequired: 'Emiterea necesită acces la modulul e-Factura.',
        confirmation: 'Confirmarea creează o ciornă imuabilă și pornește emiterea. Dacă rezultatul furnizorului este incert, verifică starea înainte de orice anulare sau recreare.',
        continue: 'Continuă la factură', issue: 'Emite factura', issueAndEmail: 'Emite și trimite', submitting: 'Se înregistrează…',
        processingTitle: 'Emiterea este în curs', processingHint: 'Cererea a fost acceptată. Starea se actualizează automat; poți închide fereastra fără să dublezi operațiunea.',
        attentionTitle: 'Este necesară o verificare', attentionHint: 'Factura nu trebuie recreată înainte de reconcilierea rezultatului.',
        issuedTitle: 'Factura a fost emisă', issuedHint: 'Starea emailului este urmărită separat de emiterea fiscală.',
        invoiceState: 'Stare factură', emailState: 'Stare email', smtpHint: '„Acceptat SMTP” nu confirmă livrarea sau citirea mesajului.',
        pollError: 'Starea nu a putut fi actualizată.', pollContinues: 'Actualizarea automată va fi reîncercată.',
        emailFailedTitle: 'Factura este emisă, dar emailul necesită atenție',
        emailFailedHint: 'Reîncercarea retrimite numai emailul și nu emite o nouă factură.',
        uncertainConfirm: 'Am verificat în sistemul de email că mesajul nu a fost deja trimis.', retryReason: 'Motivul retrimiterii',
        retryEmail: 'Reîncearcă emailul', draftPreserved: 'Ciorna existentă a fost păstrată; reîncercarea nu creează altă factură.',
      },
      workflow: {
        eyebrow: 'Dosar expediție', subtitle: 'Documente, acces extern și audit într-un singur loc.',
        pageEyebrow: 'Dosar transport', carrierReference: 'Nr. transport la transportator',
        carrierUnknown: 'Transportator nespecificat', referenceUnknown: 'Nespecificat', back: 'Înapoi', backToBilling: 'Înapoi la facturare',
        folderStatus: 'Stare dosar', billing: 'Facturare', version: 'Versiune', documentCount: 'Documente', requirements: 'Documente necesare',
        addDocument: 'Adaugă document', addDocumentHint: 'Alege tipul documentului, apoi încarcă fotografia, scanul sau PDF-ul.', documentKind: 'Tip document', optionalTitle: 'Titlu opțional',
        chooseFile: 'Alege PDF sau imagine', fileHint: 'JPG, PNG, WEBP sau PDF · maximum 25 MiB', fileTooLarge: 'Fișierul depășește limita de 25 MiB.', upload: 'Încarcă documentul',
        documents: 'Documentele dosarului', noDocuments: 'Nu există documente încărcate.', reviewReason: 'Motiv (obligatoriu la respingere/arhivare)',
        originalDate: 'Data primirii originalului', reasonRequired: 'Completează motivul pentru respingere sau arhivare.',
        download: 'Descarcă', accept: 'Acceptă', reject: 'Respinge', archive: 'Arhivează', removeFromFile: 'Elimină din dosar',
        untitledDocument: 'Document fără titlu', fileSource: 'Dosar transport',
        transportDocuments: 'Documente încărcate pe transport', transportDocumentsHint: 'Aici apar fotografia sau scanul CMR și actele existente încărcate de dispecer ori șofer.',
        transportDocumentsUnavailable: 'Documentele existente ale transportului nu au putut fi încărcate.', noTransportDocuments: 'Nu există încă o poză CMR sau alte documente pe transport.',
        cmrPhotoSource: 'Poză / scan CMR', transportDocumentSource: 'Document transport', openDocument: 'Deschide',
        uploadLink: 'Link de încărcare pentru partener', uploadLinkHint: 'Partenerul poate încărca documente fără cont. Linkul expiră în maximum 30 de zile.',
        validity: 'Valabilitate (zile)', createLink: 'Creează link', copy: 'Copiază', copied: 'Copiat', copyFailed: 'Linkul nu a putut fi copiat.',
        openLink: 'Deschide', revoke: 'Revocă', history: 'Istoric și comentarii', noHistory: 'Nu există încă activitate în dosar.', commentPlaceholder: 'Adaugă un comentariu intern…', addComment: 'Adaugă comentariul',
      },
      publicUpload: {
        eyebrow: 'Încărcare securizată', title: 'Documente transport', subtitle: 'Trimite documentele cerute fără să creezi un cont.',
        checking: 'Se verifică linkul…', missingToken: 'Linkul nu conține codul temporar necesar.',
        unavailableTitle: 'Link indisponibil', unavailable: 'Linkul a expirat, a fost revocat sau nu mai este disponibil.',
        requestNew: 'Solicită un link nou persoanei tale de contact.', transport: 'Transport', expires: 'Expiră',
        requestedDocuments: 'Documente solicitate', optional: 'opțional', documentType: 'Tip document', optionalTitle: 'Titlu opțional',
        titlePlaceholder: 'De exemplu: CMR semnat', chooseFile: 'Alege fotografia, scanul sau PDF-ul',
        fileHint: 'JPG, PNG, WEBP sau PDF · maximum 25 MiB', fileTooLarge: 'Fișierul depășește limita de 25 MiB.',
        submit: 'Trimite documentul', uploading: 'Se încarcă…', uploadError: 'Documentul nu a putut fi încărcat.',
        successTitle: 'Document primit', successHint: 'Poți încărca încă un document folosind același link cât timp este valabil.',
        privacy: 'Codul temporar este folosit numai pentru această încărcare. Pagina nu oferă acces la date financiare sau la contul companiei.',
      },
      documentKinds: {
        cmr: 'CMR fizic', physical_cmr: 'CMR fizic', cmr_physical: 'CMR fizic', carrier_invoice: 'Factură transportator',
        pod: 'Dovadă livrare', customer_order: 'Comandă client', order: 'Comandă', delivery_proof: 'Dovadă livrare',
        delivery_note: 'Aviz', customs: 'Document vamal', temperature: 'Temperatură', taxes: 'Taxe', photo: 'Fotografie', other: 'Alt document',
      },
      states: {
        missing: 'Lipsă', partial: 'Parțial', in_review: 'În verificare', rejected: 'Respins', complete: 'Complet',
        accepted: 'Acceptat', approved: 'Aprobat', verified: 'Verificat', archived: 'Arhivat',
        draft: 'Ciornă', processing: 'În procesare', issued: 'Emisă', needs_attention: 'Necesită atenție', void: 'Anulat', reversed: 'Stornat',
        queued: 'În coadă', waiting_invoice: 'Așteaptă factura', waiting_pdf: 'Așteaptă PDF-ul', sending: 'Se trimite', smtp_accepted: 'Acceptat SMTP', failed: 'Eșuat', cancelled: 'Anulat',
        unknown: 'Necunoscut', unpaid: 'Neîncasat', paid: 'Încasat', finalizat: 'Finalizat', in_curs: 'În curs', intarziat: 'Întârziat',
      },
    },
    billing: {
      eyebrow: 'Facturare și e-Factura', loading: 'Se încarcă…', attention: 'Necesită intervenție',
      draftNumber: 'Ciornă #{{id}}',
      statuses: {
        draft: 'Ciornă', ready_to_send: 'Pregătită', sending: 'În procesare', sent: 'În procesare', pending: 'În procesare',
        not_sent: 'Netrimisă în SPV', accepted: 'Acceptată', rejected: 'Respinsă', failed: 'Eșuată',
        downloaded: 'Arhivă disponibilă', cancelling: 'Anulare neconfirmată', cancelled: 'Anulată',
      },
      submissionStatuses: {
        sending: 'În procesare', sent: 'În procesare', pending: 'În procesare', not_sent: 'Netrimisă',
        accepted: 'Acceptată', rejected: 'Respinsă', failed: 'Eșuată', downloaded: 'Descărcată',
      },
      attachmentKinds: { anaf_zip: 'Arhivă ANAF', receipt: 'Recipisă', xml: 'XML', pdf: 'PDF', provider_response: 'Răspuns provider', other: 'Document' },
      reference: {
        documentTypes: { fiscal: 'Factură fiscală' }, clientTypes: { b2b: 'Firmă', b2c: 'Persoană fizică' },
        productTypes: { Serviciu: 'Serviciu', Marfa: 'Marfă' },
        countries: { RO: 'România', DE: 'Germania', FR: 'Franța', IT: 'Italia', ES: 'Spania', HU: 'Ungaria', BG: 'Bulgaria', PL: 'Polonia', NL: 'Olanda', BE: 'Belgia', AT: 'Austria' },
        units: { H87: 'Bucată', KMT: 'Kilometru', HUR: 'Oră', DAY: 'Zi', MON: 'Lună', KGM: 'Kilogram', LTR: 'Litru' },
        vatKeys: { S: 'TVA standard', E: 'Scutit', O: 'În afara sferei TVA' },
      },
      actions: {
        back: 'Înapoi', new: 'Factură nouă', open: 'Deschide', retry: 'Încearcă din nou', cancel: 'Renunță', save: 'Salvează',
        saveDraft: 'Salvează ciorna', saving: 'Se salvează…', edit: 'Editează', validate: 'Verifică',
        deletePermanently: 'Șterge definitiv', deletingPermanently: 'Se șterge definitiv…', previewDraft: 'Previzualizează',
        markReady: 'Pregătește pentru trimitere', issue: 'Emite factura', issuing: 'Se emite…', send: 'Trimite în SPV', cancelInvoice: 'Anulează',
        verifyCancellation: 'Verifică anularea', storno: 'Storno total', createStorno: 'Creează storno',
        openPdf: 'Vezi PDF-ul trimis', downloadArchivedPdf: 'Descarcă PDF-ul arhivat', openExternalPdf: 'Deschide PDF-ul extern',
        reconcile: 'Reia reconcilierea', requestArchive: 'Solicită arhiva', close: 'Închide',
        refreshDocuments: 'Reîncarcă documentele', refresh: 'Reîncarcă', download: 'Descarcă', downloading: 'Se descarcă…', continue: 'Continuă', processing: 'Se procesează…',
      },
      invoiceActions: {
        open: 'Acțiuni factură', edit: 'Modifică factura', collect: 'Încasează factura', storno: 'Stornează factura',
        recurring: 'Transformă în factură recurentă', cancel: 'Anulează factura', copy: 'Copiază factura',
        units: 'Configurează U.M. pentru e-Factura', xml: 'Generează XML pentru e-Factura',
        notAvailableYet: 'Funcția necesită conectarea operației în sistemul de facturare.',
        editUnavailable: 'Factura emisă nu mai poate fi modificată.',
        stornoUnavailable: 'Disponibil după acceptarea facturii în SPV.',
        cancelUnavailable: 'Starea curentă nu permite anularea.',
        copyUnavailable: 'O ciornă storno nu poate fi copiată ca factură obișnuită.',
        unitsUnavailable: 'Unitățile de măsură pot fi schimbate numai într-o ciornă editabilă.',
        xmlUnavailable: 'XML-ul devine disponibil după acceptarea facturii în SPV.',
        xmlQueued: 'Arhiva ANAF care conține XML-ul a fost solicitată și va apărea în istoricul transmiterii.',
        xmlReady: 'Documentul XML sau arhiva ANAF este disponibilă pentru descărcare.',
      },
      actionReasons: {
        unavailable: 'Acțiunea nu este disponibilă pentru starea curentă a facturii.',
        requiresSync: 'Situația încasărilor va fi verificată înaintea operațiunii.',
        billing_collections_not_enabled: 'Încasările nu sunt activate încă pentru această firmă.',
        billing_collection_invalid_invoice: 'Factura nu permite înregistrarea unei încasări.',
        billing_collection_active_storno: 'Există deja un storno activ pentru această factură.',
        billing_collection_reconciliation_required: 'O încasare incertă trebuie reconciliată înainte.',
        billing_operation_in_progress: 'O altă operațiune este deja în curs.',
        billing_invoice_has_collections: 'Factura are încasări. Corectează situația în sistemul de facturare și sincronizează din nou.',
      },
      collections: {
        title: 'Încasările facturii', description: 'Sincronizează soldul și înregistrează plățile confirmate de furnizorul de facturare.',
        status: 'Stare plată', paid: 'Încasat', remaining: 'Rămas de încasat', sync: 'Sincronizează', synced: 'Situația încasărilor a fost actualizată.',
        lastSync: 'Ultima sincronizare: {{date}}', neverSynced: 'Soldul nu a fost verificat încă.',
        staleTitle: 'Date neactualizate', staleDescription: 'Sincronizarea nu a reușit. Valorile afișate sunt ultimele cunoscute și nu trebuie interpretate ca sold zero.',
        register: 'Înregistrează o încasare', registerHint: 'Această operațiune înregistrează plata în {{currency}}; nu inițiază un transfer bancar.',
        amount: 'Sumă', issueDate: 'Data încasării', method: 'Metodă', receiptSeries: 'Serie chitanță', documentNumber: 'Număr document', mentions: 'Mențiuni',
        registerAction: 'Înregistrează', retrySame: 'Reîncearcă aceeași cerere', sameKeyRetry: 'Rezultatul poate fi incert. Reîncercarea păstrează aceeași cheie și nu creează o plată nouă.', conflict: 'Starea facturii a fost reîncărcată, iar datele introduse au fost păstrate. Revizuiește operațiunea înainte de o nouă încercare.',
        validation: 'Introdu o sumă pozitivă și data încasării.', futureDate: 'Data încasării nu poate fi în viitor.', receiptSeriesRequired: 'Introdu seria chitanței exact cum este definită în sistemul de facturare.',
        confirmed: 'Încasarea a fost confirmată.', failed: 'Furnizorul a refuzat încasarea. Nu a fost afișat un mesaj de succes.', uncertain: 'Rezultatul este incert și trebuie verificat, fără retrimiterea plății.',
        attentionTitle: 'Încasare în curs de verificare', attentionDescription: 'Folosește reconcilierea pentru a verifica furnizorul. Nu crea o intenție nouă pentru aceeași plată.',
        confirmedHistory: 'Încasări confirmate', noCollections: 'Nu există încasări confirmate la ultima sincronizare.', operations: 'Istoric operațiuni', noOperations: 'Nu există operațiuni de încasare.', attempts: '{{count}} încercări',
        statuses: { unknown: 'Necunoscută', unpaid: 'Neîncasată', partially_paid: 'Încasată parțial', paid: 'Încasată', overpaid: 'Supraplată' },
        operationStatuses: { confirmed: 'Confirmată', failed: 'Eșuată', pending: 'În așteptare', needs_attention: 'Necesită verificare' },
        methods: {
          receipt: 'Chitanță', fiscal_receipt: 'Bon fiscal', fiscal_card_receipt: 'Bon fiscal card', other_cash: 'Altă plată numerar', bank_transfer: 'Transfer bancar', postal_order: 'Mandat poștal', card: 'Card', cheque: 'Cec', promissory_note: 'Bilet la ordin', other_bank: 'Altă plată bancară', cash_on_delivery: 'Ramburs',
        },
      },
      copy: {
        title: 'Copiază factura', description: 'Creează o ciornă nouă, independentă de factura sursă.', issueDate: 'Data emiterii (opțional)', dueDate: 'Scadență', customDueDate: 'Data scadenței',
        dueModes: { preserve: 'Păstrează intervalul', remove: 'Fără scadență', custom: 'Alege data' }, create: 'Creează copia', retrySame: 'Reîncearcă aceeași copiere', validation: 'Alege data scadenței.',
        sameKeyRetry: 'Reîncercarea folosește aceeași cheie și nu dublează factura.', conflict: 'Factura sursă s-a modificat. Datele introduse au fost păstrate; revizuiește-le înainte de o nouă copiere.',
      },
      recurrenceCreate: {
        title: 'Transformă în factură recurentă', description: 'Creează un șablon independent din această ciornă. Facturile viitoare rămân ciorne și nu sunt trimise automat.',
        name: 'Denumire', interval: 'Frecvență', paymentTerm: 'Termen de plată', selectPaymentTerm: 'Selectează termenul', firstDate: 'Prima dată', endDate: 'Data finală (opțional)',
        intervals: { 1: 'Lunar', 3: 'La 3 luni', 12: 'Anual' }, create: 'Creează recurența', retrySame: 'Reîncearcă aceeași cerere', validation: 'Completează denumirea, prima dată și termenul de plată. Prima dată nu poate fi în trecut.', endDateValidation: 'Data finală nu poate preceda prima apariție.',
        scheduleHint: 'Generarea începe după 08:00, ora București, și este verificată periodic. Aparițiile ratate se recuperează manual.', sameKeyRetry: 'Reîncercarea folosește aceeași cheie și nu creează un al doilea șablon.', conflict: 'Ciorna sursă s-a modificat. Formularul a fost păstrat; revizuiește-l înainte de a continua.',
      },
      recurrences: {
        open: 'Facturi recurente', title: 'Facturi recurente', description: 'Urmărește șabloanele, calendarul și aparițiile generate.', filter: 'Stare', allStatuses: 'Toate stările', emptyTitle: 'Nu există recurențe', emptyDescription: 'Transformă o ciornă din meniul Acțiuni factură.',
        loadError: 'Recurențele nu au putut fi încărcate.', nextDate: 'Următoarea dată', everyMonths: 'La fiecare {{count}} luni', pagination: 'Pagina {{page}} din {{pages}} · {{count}} recurențe', statuses: { active: 'Activă', paused: 'În pauză', stopped: 'Oprită', completed: 'Finalizată' },
      },
      recurrenceDetail: {
        title: 'Detalii recurență', description: 'Administrează șablonul și recuperează manual aparițiile ratate.', schedule: 'Calendar', interval: 'Frecvență', firstDate: 'Prima dată', endDate: 'Data finală',
        scheduleHint: 'Calendarul inițial și frecvența nu se modifică. Pentru altă frecvență, creează o recurență nouă.', settings: 'Setări șablon', saved: 'Setările recurenței au fost salvate.', pause: 'Pune în pauză', resume: 'Reia', stop: 'Oprește definitiv', confirmStop: 'Oprești definitiv această recurență?', pauseSuccess: 'Recurența a fost pusă în pauză.', resumeSuccess: 'Recurența a fost reluată.', stopSuccess: 'Recurența a fost oprită.',
        conflict: 'Recurența s-a modificat între timp. Datele locale au fost păstrate; verifică versiunea actualizată înainte de salvare.', occurrences: 'Apariții', occurrencesHint: 'Aparițiile generate și omise sunt definitive. Numai cele ratate pot fi generate sau omise manual.', noOccurrences: 'Nu există apariții în calendar.', openInvoice: 'Deschide ciorna', generate: 'Generează azi', skip: 'Omite', generateOccurrenceSuccess: 'Ciorna pentru apariția ratată a fost generată.', skipOccurrenceSuccess: 'Apariția ratată a fost omisă.', occurrenceStatuses: { scheduled: 'Programată', generated: 'Generată', skipped: 'Omisă', missed: 'Ratată' },
      },
      pdfArchive: {
        title: 'PDF factură emisă',
        available: 'PDF-ul original este arhivat în siguranță și poate fi descărcat autentificat.',
        pending: 'PDF-ul este în curs de preluare și arhivare. Verificăm automat disponibilitatea lui.',
        failed: 'Arhivarea PDF-ului a eșuat și necesită verificare. PDF-ul extern rămâne disponibil separat, dacă există.',
        externalOnly: 'Această factură nu are un PDF arhivat. Poți folosi separat linkul extern al furnizorului.',
        missing: 'PDF-ul arhivat nu este disponibil pentru această factură.',
      },
      preview: {
        title: 'Previzualizare pentru client', description: 'Verifică aspectul și datele ciornei înainte de emitere.',
        invoice: 'FACTURĂ', draftBadge: 'CIORNĂ', notIssued: 'Fără număr fiscal', seller: 'Furnizor', buyer: 'Client',
        taxId: 'CUI', personalId: 'CNP', address: 'Adresă', registration: 'Reg. com.', iban: 'IBAN', bank: 'Bancă', contact: 'Contact', issueDate: 'Data emiterii', dueDate: 'Scadență', currency: 'Monedă', status: 'Stare',
        numberShort: 'Nr.', unitShort: 'U.M.', value: 'Valoare', preparedBy: 'Întocmit de', signature: 'Semnătura de primire',
        descriptionColumn: 'Produs / serviciu', quantity: 'Cantitate', unitPrice: 'Preț unitar', vat: 'TVA', total: 'Total',
        subtotal: 'Subtotal', vatTotal: 'TVA', grandTotal: 'Total de plată', noLines: 'Ciorna nu are încă poziții.',
        disclaimer: 'Aceasta este o previzualizare a ciornei. Numărul fiscal și aspectul PDF-ului final sunt stabilite la emiterea facturii.',
      },
      paymentTerms: {
        title: 'Termene de plată',
        description: 'Configurează opțiunile disponibile la emiterea facturilor și alege termenul implicit.',
        addTitle: 'Adaugă termen de plată', add: 'Adaugă', nameLabel: 'Denumire', namePlaceholder: 'Ex. Plată la 20 de zile',
        termLabel: 'Calcul scadență', calculationLabel: 'Mod de calcul', daysLabel: 'Număr de zile', daysPlaceholder: 'Zile',
        defaultLabel: 'Implicit', actionsLabel: 'Acțiuni', system: 'Termen de sistem', custom: 'Termen personalizat',
        protected: 'Protejat', makeDefault: 'Setează „{{name}}” ca implicit', edit: 'Editează „{{name}}”',
        editNameLabel: 'Denumire pentru „{{name}}”', delete: 'Șterge „{{name}}”',
        confirmDelete: 'Ștergi termenul „{{name}}”? Facturile deja salvate nu vor fi modificate.',
        loading: 'Se încarcă termenele de plată…', empty: 'Nu există termene de plată disponibile.',
        daysValue: '{{count}} zile calendaristice', created: 'Termenul de plată a fost adăugat.',
        updated: 'Termenul de plată a fost actualizat.', defaultUpdated: 'Termenul implicit a fost actualizat.',
        deleted: 'Termenul de plată a fost șters.',
        calculation: {
          none: 'Fără termen de plată', issueDate: 'La data emiterii', days: 'Număr de zile',
          endCurrentMonth: 'Ultima zi a lunii curente', endNextMonth: 'Ultima zi a lunii viitoare',
        },
        validation: { name: 'Introdu o denumire de maximum 100 de caractere.', days: 'Introdu un număr întreg între 1 și 3650.' },
        errors: {
          title: 'Modificarea nu a fost salvată', loadTitle: 'Termenele de plată nu au putut fi încărcate',
          validation: 'Verifică datele introduse și încearcă din nou.', notFound: 'Termenul nu mai există. Lista a fost reîncărcată.',
          nameExists: 'Există deja un termen cu această denumire.', systemProtected: 'Termenii de sistem nu pot fi modificați sau șterși.',
          limitReached: 'Ai ajuns la limita de 100 de termene de plată.', permissionDenied: 'Nu ai acces la configurarea termenelor de plată.',
          featureDisabled: 'Modulul e-Factura nu este activ pentru această firmă.', unsupportedLanguage: 'Limba selectată nu este acceptată.',
          unavailable: 'Serviciul nu este disponibil momentan. Încearcă din nou.',
        },
      },
      bankAccounts: {
        open: 'Conturi bancare', title: 'Conturi bancare',
        description: 'Administrează conturile companiei. Asocierea lor cu facturile și PDF-urile nu este încă disponibilă.',
        addTitle: 'Adaugă un cont bancar', editTitle: 'Editează contul bancar', add: 'Adaugă',
        nickname: 'Denumire', iban: 'IBAN', bankName: 'Bancă', currency: 'Monedă', noCurrency: 'Fără monedă', actions: 'Acțiuni',
        edit: 'Editează „{{name}}”', delete: 'Șterge „{{name}}”', confirmDelete: 'Ștergi contul „{{name}}”?',
        created: 'Contul bancar a fost adăugat.', updated: 'Contul bancar a fost actualizat.', deleted: 'Contul bancar a fost șters.',
        loading: 'Se încarcă conturile bancare…', emptyTitle: 'Nu există conturi bancare',
        emptyDescription: 'Adaugă primul cont bancar al companiei.',
        pagination: 'Pagina {{page}} din {{pages}} · {{count}} conturi',
        validation: {
          nickname: 'Introdu o denumire de maximum 100 de caractere.', iban: 'Introdu un IBAN valid.',
          bank_name: 'Numele băncii poate avea maximum 100 de caractere.', currency: 'Selectează o monedă disponibilă.',
        },
        errors: {
          title: 'Modificarea nu a fost salvată', loadTitle: 'Conturile bancare nu au putut fi încărcate',
          validation: 'Verifică datele introduse și încearcă din nou.', notFound: 'Contul nu mai există. Lista a fost reîncărcată.',
          ibanExists: 'Acest IBAN există deja.', nicknameExists: 'Există deja un cont cu această denumire.',
          permissionDenied: 'Nu ai acces la administrarea conturilor bancare.',
          featureDisabled: 'Modulul e-Factura nu este activ pentru această firmă.',
          unsupportedLanguage: 'Limba selectată nu este acceptată.', unavailable: 'Serviciul nu este disponibil momentan. Încearcă din nou.',
        },
      },
      list: {
        title: 'Facturi', description: 'Creează ciorne, verifică datele și urmărește emiterea și transmiterea în SPV.',
        emptyTitle: 'Nu există facturi', emptyDescription: 'Creează prima ciornă. Salvarea ei nu emite documentul fiscal.',
        filteredEmptyTitle: 'Nu există facturi în interval', filteredEmptyDescription: 'Alege alte date sau elimină filtrul pentru a vedea toate facturile.',
        filters: {
          from: 'De la', to: 'Până la', apply: 'Filtrează', clear: 'Elimină filtrul',
          hint: 'Intervalul se aplică inclusiv zilelor selectate și folosește data emiterii facturii.',
          invalid: 'Selectează ambele date și asigură-te că data de început nu este după data de sfârșit.',
          active: 'Facturi emise între {{from}} și {{to}}',
        },
        columns: { invoice: 'Factură', buyer: 'Cumpărător', issueDate: 'Data emiterii', total: 'Total', status: 'Stare', action: 'Acțiune' },
      },
      received: {
        open: 'Facturi primite', issuedInvoices: 'Facturi emise', title: 'Facturi primite din SPV',
        description: 'Vezi mesajele e-Factura primite de la furnizori și descarcă arhiva XML originală sau PDF-ul generat de ANAF.',
        loading: 'Se încarcă facturile primite…', downloading: 'Se descarcă ZIP…', downloadingPdf: 'Se generează PDF…',
        downloadZip: 'Descarcă ZIP', downloadPdf: 'Descarcă PDF',
        metadataHint: 'Numele furnizorului este identificat automat după CIF din registrul public ANAF.',
        downloadHint: 'ZIP-ul este documentul original din SPV. PDF-ul este generat la cerere de serviciul ANAF și poate fi temporar indisponibil.',
        emptyTitle: 'Nu există facturi primite',
        emptyDescription: 'ANAF nu a returnat facturi primite în intervalul selectat.',
        companyCif: 'CUI cumpărător: {{cif}}', interval: 'Interval: {{start}} – {{end}}',
        historyLimitTitle: 'Istoricul ANAF este limitat',
        historyLimit: 'Intervalul notificării nu mai este disponibil în fereastra de 60 de zile. A fost deschisă lista recentă.',
        referenceExpiredTitle: 'Referința de descărcare a expirat',
        referenceExpired: 'Lista este reîncărcată pentru a obține o referință nouă. După reîncărcare, încearcă din nou descărcarea.',
        messageLabel: 'Mesaj ANAF {{id}}', supplierUnknown: 'Furnizor necunoscut',
        filters: {
          startDate: 'De la', endDate: 'Până la', apply: 'Afișează intervalul', recent: 'Ultimele 30 de zile',
          hint: 'Poți consulta cel mult ultimele 60 de zile. Pentru pagina următoare se păstrează exact intervalul returnat de ANAF.',
        },
        columns: {
          receivedAt: 'Data ANAF', details: 'Furnizor', messageId: 'ID mesaj', uploadId: 'ID încărcare', action: 'Descărcări',
        },
        pagination: 'Pagina {{page}} din {{pages}} · {{count}} mesaje',
        errors: {
          invalidQueryTitle: 'Interval nevalid', invalidQuery: 'Intervalul notificării este incomplet, expirat sau nevalid. Este afișată lista recentă.',
          invalidFilter: 'Alege un interval valid, de cel mult 60 de zile, al cărui sfârșit nu este în viitor.',
          rateLimitedTitle: 'Limita de solicitări a fost atinsă', rateLimited: 'ANAF limitează temporar solicitările. Încearcă din nou peste {{seconds}} s.',
          notConfiguredTitle: 'Integrarea nu este configurată', notConfigured: 'Operatorul trebuie să verifice CUI-ul firmei și tokenul ANAF configurat securizat.',
          unauthorizedTitle: 'ANAF a refuzat accesul', unauthorized: 'Operatorul trebuie să verifice tokenul ANAF și drepturile certificatului pentru CUI-ul firmei.',
          unavailableTitle: 'Facturile primite nu sunt disponibile', unavailable: 'ANAF sau un serviciu necesar este temporar indisponibil. Încearcă din nou mai târziu.',
          invalidArchiveTitle: 'Arhiva nu poate fi oferită', invalidArchive: 'Arhiva ANAF nu a trecut verificările de siguranță și nu a fost descărcată.',
          pdfUnavailableTitle: 'PDF-ul ANAF nu este disponibil', pdfUnavailable: 'Conversia PDF nu a putut fi realizată momentan. Arhiva ZIP originală poate fi descărcată separat.',
          notAcceptableTitle: 'Format de descărcare neacceptat', notAcceptable: 'Formatul solicitat nu este acceptat. Reîncarcă pagina și încearcă din nou.',
          featureDisabledTitle: 'Modulul e-Factura nu este activ', featureDisabled: 'Modulul e-Factura nu este activ pentru această firmă.',
          accessDeniedTitle: 'Acces refuzat', accessDenied: 'Rolul curent nu are acces la facturile primite.',
          sessionExpiredTitle: 'Sesiune nevalidă', sessionExpired: 'Sesiunea a expirat sau nu mai este validă. Autentifică-te din nou.',
        },
      },
      pagination: { summary: 'Pagina {{page}} din {{pages}} · {{count}} facturi', previous: 'Anterior', next: 'Următor' },
      configuration: {
        missingTitle: 'Firma nu a fost identificată în sistemul de facturare',
        missingDescription: 'CIF emitent: {{cif}}. Poți salva ciorne, dar pregătirea și trimiterea rămân blocate până la configurare.',
        draftAllowed: 'CIF emitent: {{cif}}. Ciorna poate fi salvată; pregătirea și trimiterea vor rămâne blocate.',
        unavailableTitle: 'Integrarea cu furnizorul de facturare nu poate fi verificată',
        unavailableDescription: 'Serviciul este temporar indisponibil. Datele locale pot fi păstrate în ciornă.',
        blockActions: 'Pregătirea și trimiterea sunt blocate până când firma poate fi confirmată de furnizorul de facturare. Acest control nu confirmă configurarea SPV.',
      },
      form: {
        createTitle: 'Factură nouă', editTitle: 'Editează ciorna', editStornoTitle: 'Editează ciorna storno', copyTitle: 'Copiază factura',
        description: 'Completează datele facturii. Emiterea are loc numai după verificare, pregătire și trimitere.',
        copyDescription: 'Verifică datele copiate și salvează-le ca o ciornă nouă înainte de emitere.',
        copyNoticeTitle: 'Date copiate într-o factură nouă', copyNotice: 'Numărul și starea facturii originale nu se copiază. Noua factură va fi creată numai după salvare.',
        stornoEditDescription: 'Pentru storno se pot modifica numai seria și data emiterii.',
        documentSection: 'Document', documentType: 'Tip document', clientType: 'Tip client', currency: 'Monedă',
        series: 'Serie', selectSeries: 'Selectează seria', searchOptions: 'Caută în opțiuni...', seriesUnavailable: 'Seriile nu sunt disponibile momentan; nu inventa o serie.',
        issueDate: 'Data emiterii', dueDate: 'Scadență', customDueDate: 'Data scadenței', selectDate: 'Selectează data', buyerSection: 'Cumpărător',
        paymentTerms: {
          none: 'Fără termen de plată', issueDate: 'La data emiterii', days: '{{count}} zile',
          endOfCurrentMonth: 'Ultima zi a lunii curente', endOfNextMonth: 'Ultima zi a lunii viitoare', custom: 'Personalizat', configure: 'Configurează',
        },
        buyerSnapshotHint: 'Completează datele clientului căruia îi emiți factura.',
        buyerCompanyHint: 'Introdu CUI-ul firmei pentru a completa automat datele publice, apoi verifică-le.',
        buyerLookup: {
          action: 'Caută firma', actionLoading: 'Se caută…', loading: 'Căutăm firma în registrul ANAF…',
          success: 'Datele publice ale firmei au fost completate. Verifică-le înainte de a continua.',
          invalid: 'Introdu un CUI românesc valid, format din 2–10 cifre. Prefixul RO este opțional.',
          notFound: 'Firma nu a fost găsită în registrul ANAF. Completează datele manual.',
          unavailable: 'Registrul ANAF nu este disponibil momentan. Poți completa datele manual.',
          accessDenied: 'Nu ai acces la căutarea firmelor. Poți completa datele manual.',
          rateLimited: 'Ai făcut prea multe căutări. Încearcă din nou peste {{seconds}} s.',
          retry: 'Poți încerca din nou sau poți completa datele manual.',
          foreignCompany: 'Pentru firmele din afara României, completează datele manual.',
        },
        buyerName: 'Nume / denumire', cui: 'CUI client', cnp: 'CNP (opțional)', country: 'Țară', address: 'Adresă',
        city: 'Localitate', county: 'Județ', email: 'Email', phone: 'Telefon', linesSection: 'Produse și servicii',
        linesHint: 'Adaugă produsele sau serviciile pe care le facturezi. Este necesar cel puțin unul pentru emiterea facturii.',
        addLine: 'Adaugă produs sau serviciu', noLines: 'Nu ai adăugat încă niciun produs sau serviciu.', lineNumber: 'Produs / serviciu {{number}}',
        removeLine: 'Elimină produsul sau serviciul', descriptionLabel: 'Descriere', quantity: 'Cantitate', unit: 'Unitate de măsură', selectUnit: 'Selectează unitatea',
        unitPrice: 'Preț unitar', vat: 'Cotă TVA', selectVat: 'Selectează perechea TVA',
        vatUnavailable: 'Nomenclatorul TVA al furnizorului nu este disponibil.', vatLoading: 'Se încarcă nomenclatorul TVA…',
        vatReload: 'Reîncarcă nomenclatorul TVA', vatReloading: 'Se reîncarcă TVA…', productType: 'Tip produs', ublUnit: 'Unitate de măsură',
        vatKey: 'Regim TVA', vatIncluded: 'Preț cu TVA inclus', savedProduct: 'Produs sau serviciu salvat',
        savedProductHint: 'Selectează un articol din nomenclator pentru a completa automat rândul.', selectSavedProduct: 'Alege din nomenclator',
        searchProducts: 'Caută produsul sau serviciul...', saveProduct: 'Salvează pentru a-l reutiliza pe alte facturi după emitere',
        errors: { required: 'Câmp obligatoriu.', invalid_due_date: 'Scadența nu poate preceda data emiterii.', positive: 'Cantitatea trebuie să fie pozitivă.', nonnegative: 'Prețul nu poate fi negativ.' },
      },
      lkwIssue: {
        title: 'Emite factura din rândurile extrase',
        description: '{{count}} poziții active vor fi preluate în factura fiscală, în EUR.',
        loading: 'Se încarcă datele pentru emitere…',
        linesTitle: 'Mapare poziții extrase',
        linesHint: 'Toate cele {{count}} poziții active sunt incluse. Pozițiile excluse nu vor fi trimise.',
        vatForRate: 'Regim TVA pentru cota {{rate}}%',
        vatMissing: 'Furnizorul de facturare nu oferă această cotă TVA.',
        confirmation: 'Prin continuare se creează factura fiscală, se verifică și se trimite către SPV. Nu reîncerca după o eroare de rețea înainte să verifici lista de facturi.',
        issue: 'Emite și trimite în SPV',
        continueIssue: 'Continuă emiterea',
        invoiceHistoryUnavailable: 'Facturile existente nu au putut fi verificate. Emiterea este blocată pentru a evita o dublură.',
        queued: 'Factura a fost creată și acceptată pentru procesare. PDF-ul va fi arhivat și va apărea aici imediat ce este disponibil.',
        created: 'Factura e-Factura #{{id}}',
        pdfReady: 'PDF-ul emis este disponibil.',
        pdfPending: 'Factura este procesată; verificăm automat disponibilitatea PDF-ului.',
        polling: 'Se actualizează automat starea facturii și a PDF-ului…',
        openForDetails: 'Deschide factura pentru starea completă și eventualele corecții.',
        openInvoice: 'Deschide în e-Factura',
        draftKept: 'Ciorna e-Factura creată a fost păstrată. Deschide-o pentru corectare înainte de o nouă încercare.',
        validationTitle: 'Factura nu poate fi emisă încă',
        validation: {
          unsaved: 'Salvează întâi modificările făcute în antet sau în pozițiile extrase.',
          series: 'Selectează seria de facturare.',
          issue_date: 'Completează data emiterii.',
          due_date: 'Scadența nu poate preceda data emiterii.',
          buyer_cui: 'Completează CUI-ul cumpărătorului.',
          buyer_name: 'Completează denumirea cumpărătorului.',
          buyer_address: 'Completează adresa cumpărătorului.',
          buyer_country: 'Selectează țara cumpărătorului.',
          lines_empty: 'Nu există poziții active de facturat.',
          lines_limit: 'O factură poate conține cel mult 100 de poziții. Exclude poziții sau emite facturi separate.',
          line_description: 'Fiecare poziție trebuie să aibă o denumire.',
          line_quantity: 'Cantitățile trebuie să fie mai mari decât zero.',
          line_quantity_precision: 'Cantitățile pot avea maximum trei zecimale pentru e-Factura.',
          line_unit: 'Fiecare poziție trebuie să aibă o unitate de măsură.',
          line_price: 'Prețurile negative nu pot fi trimise pe o factură fiscală obișnuită.',
          line_price_precision: 'Prețurile unitare pot avea maximum două zecimale pentru e-Factura.',
          line_vat: 'Selectează un regim TVA valid pentru fiecare cotă extrasă.',
        },
      },
      conflict: {
        title: 'Factura a fost modificată între timp',
        description: 'Editările tale au fost păstrate local. Versiunea curentă de pe server este {{version}}; compară datele înainte de a continua.',
        loadServer: 'Încarcă versiunea serverului',
        review: 'Am revizuit datele',
      },
      detail: {
        title: 'Detaliu factură', summaryTitle: 'Rezumat factură', summaryDescription: 'Verifică dacă datele de mai jos sunt corecte înainte de a continua.', version: 'Versiunea {{version}}', saved: 'Ciorna a fost salvată.',
        invoiceData: 'Date factură', sellerSection: 'Firma emitentă', sellerName: 'Denumire firmă emitentă', sellerCui: 'CUI firmă emitentă', sellerAddress: 'Adresa firmei emitente', sellerCountry: 'Țara firmei emitente', contact: 'Contact', missingValue: 'Lipsește', unknownValidationField: 'Informație necesară facturării', sellerValidationHint: 'Completează această informație în datele firmei emitente.', seriesValidationHint: 'Apasă „Editează” și selectează o serie de facturare.', buyerValidationHint: 'Apasă „Editează” și completează datele cumpărătorului.', linesValidationHint: 'Apasă „Editează” și corectează produsul sau serviciul indicat.', invoiceValidationHint: 'Apasă „Editează” și verifică datele facturii.', created: 'Creată', stornoFor: 'Storno pentru', openOriginalInvoice: 'Deschide factura inițială', net: 'Bază', vat: 'TVA', total: 'Total',
        validationErrors: 'Probleme de validare', valid: 'Factura este validă', invalid: 'Factura necesită corecții',
        validDescription: 'Datele au trecut verificarea. Pregătirea pentru trimitere este o acțiune separată.',
        invalidDescription: 'Corectează problemele afișate înainte de pregătire.', readySuccess: 'Factura este pregătită pentru trimitere.',
        sendQueued: 'Operația a fost acceptată pentru procesare. Aceasta nu reprezintă confirmarea fiscală.',
        anafProcessing: 'Factura este în procesare de către ANAF. Vei fi notificat când este disponibilă în SPV.',
        pdfPending: 'PDF-ul trimis va putea fi deschis aici imediat ce este generat.',
        cancelSuccess: 'Starea anulării a fost actualizată.', history: 'Istoric transmiteri',
        historyHint: 'Aici vezi ce se întâmplă după trimiterea facturii către SPV.', noSubmissions: 'Nu există încă transmiteri.',
        submissionTitle: 'Trimitere către SPV', submissionDate: 'Inițiată la {{date}}',
        submissionMeta: '{{phase}} · {{attempts}} încercări · {{date}}', attentionDescription: 'Procesarea automată s-a oprit. Verifică operația înainte de reconciliere.',
        noAttachments: 'Nu există documente disponibile pentru această transmitere.', archiveQueued: 'Descărcarea arhivei a fost acceptată pentru procesare.',
        archiveAvailable: 'Arhiva disponibilă a fost reîncărcată.', reconcileQueued: 'Reconcilierea a fost acceptată pentru procesare.',
      },
      storno: {
        title: 'Creează storno total', description: 'Alege explicit dacă încasarea asociată trebuie eliminată din sistemul de facturare. Aceasta nu dovedește un transfer bancar.',
        keepPayment: 'Păstrează încasarea', keepPaymentHint: 'Trimite refund_payment=false.',
        refundPayment: 'Elimină încasarea din sistemul de facturare', refundPaymentHint: 'Trimite refund_payment=true către furnizor.',
      },
      confirm: {
        cancel: 'Sigur vrei să anulezi această factură?',
        verifyCancellation: 'Verifici dacă anularea incertă a fost confirmată de furnizorul de facturare?',
        deleteInvoice: 'Ștergi definitiv această factură din AtruX? Documentele din Oblio sau SPV nu vor fi șterse. Operațiunea nu poate fi anulată.',
        deleteInvoiceWithAttachments: 'Ștergi definitiv această factură și fișierele ei atașate din AtruX? Documentele din Oblio sau SPV nu vor fi șterse. Operațiunea nu poate fi anulată.',
      },
      errors: {
        loadList: 'Facturile nu au putut fi încărcate.', loadInvoice: 'Factura nu a putut fi încărcată.',
        referenceData: 'Nomenclatoarele generale nu au putut fi încărcate.', series: 'Seriile de facturare nu au putut fi încărcate.',
        vatRates: 'Cotele TVA nu au putut fi încărcate.', products: 'Produsele și serviciile salvate nu au putut fi încărcate.', partialResources: 'Unele nomenclatoare nu sunt disponibile',
        save: 'Ciorna nu a putut fi salvată.', action: 'Operația nu a putut fi finalizată.',
        uncertainCreate: 'Răspunsul s-a pierdut. Verifică lista înainte de a încerca din nou, pentru a evita o ciornă duplicată.',
        stateReloaded: 'Starea curentă a fost reîncărcată înainte de o eventuală nouă încercare.',
        invoiceUnavailable: 'Factura nu mai este disponibilă în firma curentă. Lista a fost reîncărcată.',
        retryAfter: 'Încearcă din nou peste {{seconds}} s',
      },
    },
    expiredDocuments: {
      eyebrow: 'Conformitate documente',
      title: 'Acte expirate',
      subtitle: 'Restanțele rămân vizibile până la înregistrarea unui înlocuitor valabil.',
      currentCount: 'Restanțe curente',
      refresh: 'Reîncarcă situația',
      tabs: { open: 'Nerezolvate', history: 'Istoric', reports: 'Rapoarte' },
      filters: {
        ownerType: 'Tip titular', allOwners: 'Toți titularii', ownerId: 'ID titular',
        ownerIdPlaceholder: 'Ex. 42', category: 'Categorie', categoryPlaceholder: 'Ex. itp',
        from: 'Expirare de la', to: 'Expirare până la', reset: 'Resetează', apply: 'Aplică filtrele',
      },
      columns: { owner: 'Titular', document: 'Document', expiration: 'Data expirării', overdue: 'Întârziere', resolution: 'Rezolvare', actions: 'Acțiuni' },
      ownerTypes: { truck: 'Camion', trailer: 'Remorcă', passenger_car: 'Autoturism', van: 'Dubă', driver: 'Șofer' },
      categories: {
        itp: 'ITP', asigurare: 'Asigurare', carte_identitate: 'Carte de identitate',
        licenta_transport: 'Licență transport', tahograf: 'Tahograf', altele: 'Altele',
        certificat_conformitate: 'Certificat de conformitate', contract_asigurare: 'Contract de asigurare',
        asigurari_rca: 'RCA', inspectii_tehnice: 'Inspecții tehnice periodice',
        carte_identitate_vehicul: 'Carte de identitate a vehiculului', ec_certificat_conformitate: 'Certificat de conformitate EC',
        copie_conforma: 'Copie conformă', procedura_instalare: 'Procedură de instalare', larm: 'LARM',
        rovigneta: 'Rovinietă', rovinieta: 'Rovinietă', rca: 'RCA', casco: 'CASCO', civ: 'CIV',
        certificat_inmatriculare: 'Certificat de înmatriculare', buletin: 'Carte de identitate',
        permis_de_conducere: 'Permis de conducere', atestate: 'Atestate', uncategorized: 'Necategorizat',
      },
      openStatus: 'Expirat — act nou neînregistrat',
      resolved: 'Rezolvat',
      daysOverdue_one: '{{count}} zi întârziere',
      daysOverdue_few: '{{count}} zile întârziere',
      daysOverdue_other: '{{count}} de zile întârziere',
      replacementExpiration: 'Înlocuitor valabil până la',
      notResolved: 'Nerezolvat', untitled: 'Document fără titlu',
      imported: 'Perioadă observată la import', openFolder: 'Deschide dosarul',
      historyFilter: 'Afișează', historyAll: 'Toate perioadele', historyResolved: 'Doar rezolvate',
      pagination: 'Pagina {{page}} din {{pages}} · {{count}} rezultate',
      paginationPage: 'Pagină',
      empty: {
        title: 'Nu există rezultate', description: 'Nu sunt restanțe care să corespundă filtrelor selectate.',
        reportsTitle: 'Nu există rapoarte', reportsDescription: 'Nu a fost publicat încă niciun raport vizibil pentru tine.',
      },
      reports: {
        reportNumber: 'Raport #{{id}}', published: 'Publicat', snapshot: 'Situație la', back: 'Înapoi la rapoarte',
        immutable: 'Acest raport păstrează situația salvată la momentul generării.',
      },
      replace: {
        action: 'Înregistrează înlocuitor', eyebrow: 'Restanță selectată', title: 'Înregistrează înlocuitor',
        documentTitle: 'Titlul actului nou', expirationDate: 'Noua dată de expirare', issuingDate: 'Data emiterii',
        futureIssuingWarning: 'Dacă actul intră în vigoare în viitor, restanța poate rămâne deschisă până atunci.',
        file: 'Fișier (opțional)', chooseFile: 'Alege un fișier', submit: 'Salvează înlocuitorul',
        success: 'Înlocuitorul a fost salvat. Situația a fost reîncărcată.',
        verifiedSuccess: 'Salvarea a fost confirmată după verificarea situației curente.',
        verifiedSavedStillOpen: 'Actul a fost salvat, dar restanța este încă deschisă. Verifică data emiterii și valabilitatea.',
      },
      errors: {
        load: 'Situația nu a putut fi încărcată.', reportUnavailable: 'Raportul nu există sau nu mai este accesibil.',
        invalidResolution: 'Restanța s-a schimbat sau înlocuitorul nu corespunde. Situația a fost reîncărcată.',
        validation: 'Verifică datele marcate în formular.', permission: 'Nu mai ai permisiunea de a înregistra acest înlocuitor.',
        retryAfter: 'Prea multe solicitări. Încearcă din nou peste {{seconds}} secunde.',
        uncertainWrite: 'Conexiunea s-a întrerupt și salvarea nu a putut fi confirmată. Situația a fost verificată; nu retrimite înainte de o nouă reîncărcare.',
        writeNotFound: 'Salvarea nu apare în situația sau dosarul reîncărcat. Poți încerca din nou.',
        save: 'Înlocuitorul nu a putut fi salvat.',
      },
      accessDeniedTitle: 'Secțiunea nu este disponibilă',
      accessDeniedDescription: 'Rolul sau modulele active nu permit accesul la situația centralizată.',
      notification: {
        expiringSoon: 'Urmează să expire', expiresToday: 'Expiră astăzi', expired: 'Expirat',
        report: 'Raport acte expirate', openReport: 'Vezi raportul',
      },
      folder: { renewalRequired: 'Reînnoire necesară', overdueReplacement: 'Act expirat — înlocuitor necesar' },
    },
    roles: {
      fleetManager: 'Manager Flotă', driver: 'Șofer', dispatcher: 'Dispecer', economist: 'Economist', administrator: 'Administrator', user: 'Utilizator',
      guest: 'Nelogat',
    },
    dashboard: {
      welcome: 'Bun venit,', generalStats: 'Statistici generale', active: 'Active',
      completed: 'Finalizate', activeDrivers: 'Șoferi activi', quickActions: 'Acțiuni rapide',
      quickActionsHelp: 'Accesează rapid fluxurile principale',
      adminActionsHelp: 'Accesează rapid fluxurile administrative',
      search: 'Caută funcții din dashboard', clearSearch: 'Șterge căutarea',
      noMatchingActions: 'Nu există funcții potrivite pentru căutarea introdusă.',
      resetSearch: 'Resetează căutarea', helpTitle: 'Aveți nevoie de ajutor?',
      helpText: 'Contactați echipa de suport pentru orice întrebări legate de aplicație sau transporturi.',
      adminHelpText: 'Contactați echipa de suport pentru întrebări de administrare sau probleme tehnice.',
      adminHelpTitle: 'Suport administrator',
      deleteTransportTitle: 'Confirmare Ștergere Transport',
      deleteTransportSuccess: 'Transport #{{id}} șters cu succes',
      deleteTransportError: 'Eroare la ștergerea transportului',
      statuses: {
        arrivedAtLoading: 'Ajuns la încărcare', loadingStarted: 'Încărcare marfă',
        loadingEnded: 'Încărcare finalizată', arrivedAtUnloading: 'Ajuns la descărcare',
        unloadingStarted: 'Se descarcă', unloadingEnded: 'Descărcare finalizată', delivered: 'Livrat',
        inTransit: 'În tranzit', assigned: 'Atribuit', pending: 'În așteptare', unknown: 'Necunoscut',
      },
      actions: {
        gpsTracking: { title: 'GPS Tracking', description: 'Urmărește în timp real camioanele și cursele simulate pe hartă.' },
        trucks: { title: 'Camioane', description: 'Vezi și gestionează camioanele din flotă.', availableDescription: 'Vezi toate camioanele disponibile.' },
        trailers: { title: 'Remorci', description: 'Consultă și editează remorcile active.', availableDescription: 'Consultă toate remorcile disponibile.' },
        addTruck: { title: 'Adaugă camion', description: 'Înregistrează un camion nou în flotă.', quickDescription: 'Înregistrează rapid un camion nou.' },
        addTrailer: { title: 'Adaugă remorcă', description: 'Înregistrează o remorcă nouă.' },
        transports: { title: 'Transporturi', description: 'Vezi toate transporturile aflate în desfășurare.' },
        createTransport: { title: 'Creare transport', description: 'Adaugă un nou transport în sistem.' },
        quotations: { title: 'Cotații transport', description: 'Calculează și salvează prețul recomandat pentru un transport dedicat.', adminDescription: 'Calculează și consultă prețurile recomandate pentru transport dedicat.' },
        customers: { title: 'Clienți casă de expediție', description: 'Vezi și adaugă clienții comenzilor intermediate.' },
        carriers: { title: 'Transportatori subcontractați', description: 'Vezi partenerii externi care execută transporturile.' },
        freightBilling: { title: 'Facturare expediții', description: 'Verifică dosarele și CMR-urile, facturează individual sau în lot și urmărește emiterea și emailul.', badge: 'Casă de expediție' },
        cmr: { title: 'Gestionare CMR', description: 'Vizualizează și gestionează toate CMR-urile.' },
        uit: { title: 'UIT e-Transport', description: 'Vezi vehiculele și codurile UIT active din ANAF.' },
        billing: { title: 'Facturare', description: 'Creează facturi și urmărește transmiterea lor în SPV.' },
        receivedInvoices: { title: 'Facturi din SPV', description: 'Vezi facturile primite de la furnizori prin ANAF e-Factura și descarcă arhiva XML.' },
        profitability: { title: 'Profitabilitate', description: 'Raport lunar tur-retur, costuri fixe și split dispeceri.' },
        fuelExpenses: { title: 'Cheltuieli combustibil', description: 'Încarcă și verifică facturile de combustibil și taxele de drum.' },
        otherInvoices: { title: 'Facturi lunare LKW WALTER', description: 'Organizează extragerile pe luni și pregătește ciorna centralizată editabilă.' },
        drivers: { title: 'Șoferi', description: 'Listă completă cu toți șoferii înregistrați.' },
        observations: { title: 'Observații șoferi', description: 'Adaugă și vezi observații pe transport sau șofer.' },
        optifleet: { title: 'Date tahograf Optifleet', description: 'Date tahograf Optifleet pe perioadă selectată.' },
        addDriver: { title: 'Adaugă șofer', description: 'Adaugă un șofer nou în sistem.' },
        users: { title: 'Utilizatori', description: 'Administrează șoferi, dispeceri și administratori.' },
        adminCmr: { title: 'CMR-uri', description: 'Vizualizează și filtrează toate CMR-urile.' },
        adminTransports: { title: 'Transporturi', description: 'Vezi și administrează toate transporturile.' },
        adminDrivers: { title: 'Șoferi', description: 'Gestionează toți șoferii din sistem.' },
        adminCreateTransport: { title: 'Creare transport', description: 'Creează transporturi noi în sistem.' },
        expiredDocuments: { title: 'Acte expirate', description: 'Monitorizează restanțele până la înregistrarea înlocuitorului.' },
      },
    },
    fleetDashboard: {
      loadError: 'Eroare la încărcarea datelor dashboard', loadErrorTitle: 'Datele flotei nu s-au încărcat',
      welcome: 'Bun venit, {{name}}', assistance: 'Asistență', logout: 'Deconectare', fleetState: 'Starea flotei',
      attentionItems_one: '{{count}} element necesită atenție', attentionItems_few: '{{count}} elemente necesită atenție', attentionItems_other: '{{count}} de elemente necesită atenție',
      vehiclesInMaintenance_one: '{{count}} vehicul în mentenanță', vehiclesInMaintenance_few: '{{count}} vehicule în mentenanță', vehiclesInMaintenance_other: '{{count}} de vehicule în mentenanță',
      expiringDocumentsCount_one: '{{count}} document aproape de expirare', expiringDocumentsCount_few: '{{count}} documente aproape de expirare', expiringDocumentsCount_other: '{{count}} de documente aproape de expirare', checkDocuments: 'Verifică valabilitatea documentelor',
      fleetHealthy: 'Flota este în regulă', noUrgentItems: 'Nu sunt elemente urgente', unspecifiedDate: 'Dată nespecificată',
      overview: 'Privire de ansamblu', cardHint: 'Apasă un card pentru detalii', trucks: 'Camioane', trailers: 'Remorci',
      availableInUse: '{{available}} disponibile · {{inUse}} în cursă', availableUsed: '{{available}} disponibile · {{inUse}} utilizate',
      activeInterventions: 'Intervenții active', scheduledInProgress: '{{scheduled}} programate · {{inProgress}} în lucru',
      expiringDocuments: 'Documente ce expiră', expiringDocumentsHelp: 'Documente cu termen apropiat',
      shortcuts: 'Scurtături', whatNext: 'Ce vrei să faci?',
      shortcutsHelp: 'Cele mai folosite operațiuni sunt grupate aici, în ordinea firească a lucrului.',
      actions: {
        scheduleIntervention: ['Programează o intervenție', 'Deschide direct formularul de service'],
        serviceCalendar: ['Vezi calendarul service', 'Intervenții și revizii viitoare'],
        manageTrucks: ['Gestionează camioanele', 'Disponibilitate, detalii și documente'],
        manageTrailers: ['Gestionează remorcile', 'Listă, stare și documente'],
        manageCars: ['Gestionează autoturismele', 'Evidență, detalii și documente'],
        manageVans: ['Gestionează dubele', 'Capacitate, dotări și documente'],
        allInterventions: ['Toate intervențiile', 'Urmărește starea lucrărilor'],
        fleetDocuments: ['Documentele flotei', 'Valabilitate și expirări'],
        expiredDocuments: ['Acte expirate', 'Restanțe curente, istoric și rapoarte'],
      },
      planning: 'Planificare', upcomingInterventions: 'Următoarele intervenții', viewAll: 'Vezi toate',
      noScheduledInterventions: 'Nicio intervenție programată', scheduleNow: 'Programează acum',
      compliance: 'Conformitate', manage: 'Gestionează', documentsValid: 'Toate documentele verificate sunt în termen.',
      expires: 'Expiră', helpTitle: 'Ai nevoie de ajutor?',
      helpText: 'Primești suport pentru flotă, documente și intervenții.', contactSupport: 'Contactează suportul',
      directSupport: 'Asistență directă', supportManager: 'Manager Suport Flotă',
      callHelp: 'Sună-mă pentru orice solicitare legată de flotă, documente sau intervenții.',
      directPhone: 'Telefon direct', callNow: 'Sună acum',
    },
    app: {
      companyTemporarilyUnavailable: 'Serviciul firmei este temporar indisponibil',
      companyUnavailable: 'Firma nu este disponibilă',
      retryLater: 'Încearcă din nou peste câteva momente.',
      checkAddress: 'Verifică adresa folosită sau contactează administratorul firmei.',
      sessionExpired: 'Sesiunea a expirat sau a fost revocată.',
      connectionError: 'Eroare de conectare',
    },
    profile: { languageTitle: 'Limba interfeței', languageHelp: 'Preferința este salvată în profilul tău.' },
    apiErrors: {
      too_many_files: 'Poți atașa maximum {{max_files}} fișiere din acest tip.',
      file_too_large: 'Fișierul depășește limita de {{max_size_mib}} MiB.',
      batch_too_large: 'Fișierele selectate depășesc limita totală de {{max_size_mib}} MiB.',
      empty_file: 'Fișierul este gol.',
      invalid_file_extension: 'Extensia fișierului nu este acceptată.',
      file_mime_mismatch: 'Tipul declarat al fișierului nu corespunde extensiei.',
      file_content_mismatch: 'Conținutul fișierului nu corespunde tipului declarat.',
      invalid_file_structure: 'Fișierul este deteriorat sau nu are o structură validă.',
      invalid_filename: 'Numele fișierului nu este valid.',
      unsupported_language: 'Limba selectată nu este acceptată.',
      permission_denied: 'Nu ai permisiunea necesară pentru această acțiune.',
      authentication_failed: 'Autentificarea a eșuat. Conectează-te din nou.',
      validation_error: 'Unele date nu sunt valide.',
      invalid_idempotency_key: 'Cheia de siguranță a distribuirii nu este validă. Reîncearcă distribuirea.',
      invalid_share_expiry: 'Perioada de acces trebuie să fie între 1 și 30 de zile.',
      tenant_conflict: 'Linkul nu aparține firmei deschise. Folosește exact linkul primit.',
      dispatcher_required: 'Doar administratorii și dispecerii pot gestiona distribuirile.',
      feature_not_enabled: 'Gestionarea transporturilor nu este activă pentru această firmă.',
      efactura_anaf_invalid_query: 'Intervalul sau pagina pentru facturile primite nu este validă.',
      efactura_anaf_invalid_reference: 'Referința de descărcare a expirat. Lista va fi reîncărcată.',
      efactura_anaf_rate_limited: 'Sunt prea multe solicitări către ANAF. Așteaptă înainte de a încerca din nou.',
      efactura_anaf_not_configured: 'Integrarea pentru facturile primite nu este configurată pentru această firmă.',
      efactura_anaf_unauthorized: 'ANAF a refuzat accesul. Tokenul sau drepturile certificatului trebuie verificate de operator.',
      efactura_anaf_unavailable: 'Serviciul ANAF este temporar indisponibil.',
      efactura_anaf_invalid_archive: 'Arhiva returnată de ANAF nu a trecut verificările de siguranță.',
      efactura_anaf_pdf_unavailable: 'Conversia PDF ANAF este temporar indisponibilă. Poți descărca separat arhiva ZIP originală.',
      not_acceptable: 'Formatul solicitat nu este acceptat de această operațiune.',
      billing_request_too_large: 'Cererea de facturare depășește limita permisă.',
      billing_pdf_not_found: 'PDF-ul arhivat nu există pentru această factură.',
      billing_pdf_not_ready: 'PDF-ul este încă în curs de arhivare. Reîncearcă în câteva momente.',
      billing_pdf_unavailable: 'PDF-ul arhivat este temporar indisponibil.',
      billing_pdf_rate_limited: 'Sunt prea multe solicitări pentru PDF. Așteaptă înainte de a încerca din nou.',
      billing_collections_not_enabled: 'Încasările nu sunt activate pentru această firmă.',
      billing_collection_invalid_invoice: 'Factura nu permite această încasare.',
      billing_collection_active_storno: 'Un storno activ blochează încasările noi.',
      billing_collection_exceeds_balance: 'Suma depășește soldul rămas al facturii.',
      billing_collection_invalid_receipt_series: 'Seria chitanței nu este validă în sistemul de facturare.',
      billing_collection_reconciliation_required: 'O încasare incertă trebuie reconciliată înainte de o operațiune nouă.',
      billing_invoice_attachment_confirmation_required: 'Factura are fișiere atașate. Starea a fost reîncărcată; verifică avertismentul și confirmă din nou ștergerea definitivă a fișierelor.',
      billing_invoice_changed: 'Factura a fost modificată între timp. Starea curentă a fost reîncărcată; verific-o și confirmă din nou dacă vrei să o ștergi.',
      billing_invalid_invoice_status: 'Starea facturii s-a schimbat, iar ștergerea nu mai este disponibilă.',
      billing_reconciliation_required: 'Ștergerea este blocată de istoricul extern, de o operațiune în curs sau de proprietatea neconfirmată a unui fișier. Verifică starea facturii înainte de a continua.',
      freight_managed_invoice_immutable: 'Factura este gestionată prin dosarul de transport. Folosește fluxul acelui dosar pentru modificări sau eliminare.',
      billing_operation_in_progress: 'O operațiune de facturare este deja în curs. Verifică starea înainte de a continua.',
      billing_idempotency_key_required: 'Cererea are nevoie de cheia de siguranță. Reîncearcă aceeași operațiune.',
      billing_idempotency_conflict: 'Cheia de siguranță aparține altor date. Revizuiește operațiunea înainte de a continua.',
      billing_invoice_has_collections: 'Factura are încasări confirmate sau incerte. Corectează situația în sistemul de facturare și sincronizează.',
      billing_copy_result_deleted: 'Ciorna creată anterior prin această copiere a fost ștearsă. Pornește o copiere nouă după revizuire.',
      problems_access_denied: 'Accesul la problemele raportate nu mai este disponibil pentru acest link.',
      not_found: 'Resursa solicitată nu este disponibilă.',
      idempotency_content_conflict: 'Această încercare de distribuire a fost modificată. Pornește o distribuire nouă.',
      share_unavailable: 'Acest acces a expirat, a fost revocat sau nu mai este disponibil.',
      rate_limited: 'Sunt prea multe solicitări. Așteaptă înainte de a încerca din nou.',
      rate_limit_unavailable: 'Verificarea limitei de acces este temporar indisponibilă. Încearcă din nou.',
      service_unavailable: 'Serviciul este temporar indisponibil. Încearcă din nou.',
      invalid_share_code: 'Linkul de acces este invalid sau nu mai este disponibil.',
      maintenance_baseline_required: 'Completează punctul de pornire sau scadența pentru fiecare interval recurent.',
      maintenance_can_unavailable: 'Planul după kilometri necesită o asociere CargoTrack și o citire CAN validă, mai nouă de 24 de ore.',
      maintenance_calendar_interval_conflict: 'Alege fie interval în zile, fie interval în luni.',
      maintenance_invalid_filter: 'Unul dintre filtrele de mentenanță nu este valid.',
      maintenance_object_already_associated: 'Obiectul CargoTrack este deja asociat altui camion.',
      maintenance_service_already_exists: 'Există deja o intervenție activă pentru acest ciclu.',
      maintenance_cycle_locked: 'Scadența nu mai poate fi schimbată după programarea sau finalizarea intervenției.',
      maintenance_completion_locked: 'Datele de finalizare ale acestei intervenții sunt protejate.',
      maintenance_historical_service_use_source: 'Folosește intervenția finalizată ca sursă atunci când creezi planul.',
      maintenance_intervention_delete_forbidden: 'Intervenția face parte din istoricul de mentenanță și nu poate fi ștearsă.',
      maintenance_sync_in_progress: 'Există deja o actualizare CargoTrack în desfășurare.',
      maintenance_refresh_throttled: 'Actualizarea manuală este limitată. Așteaptă înainte de a încerca din nou.',
      maintenance_limiter_unavailable: 'Verificarea limitei de actualizare este temporar indisponibilă.',
      maintenance_due_required: 'Completează cel puțin o scadență: kilometri sau dată.',
      maintenance_interval_required: 'O lucrare recurentă are nevoie de un interval.',
      maintenance_type_required: 'Alege un tip de mentenanță activ.',
      request_failed: 'Cererea nu a putut fi finalizată.',
      field_required: 'Acest câmp este obligatoriu.', invalid: 'Valoarea nu este validă.',
    },
    transportShare: {
      management: {
        action: 'Share spre colaboratori',
        eyebrow: 'Acces extern read-only',
        title: 'Share spre colaboratori',
        subtitle: 'Gestionează linkurile pentru transportul',
        created: 'Linkul de acces a fost creat.',
        visibilitySaved: 'Accesul la probleme a fost actualizat pentru acest link.',
        revoked: 'Linkul a fost revocat.',
        alreadyUnavailable: 'Linkul era deja indisponibil și a fost marcat ca revocat.',
        copied: 'Linkul a fost copiat.',
        copyFailed: 'Linkul nu a putut fi copiat. Selectează-l și copiază-l manual.',
        invalidEmail: 'Introdu o adresă de email validă.',
        emailFieldsRequired: 'Completează expeditorul, subiectul și mesajul.',
        emailSent: 'Emailul a fost trimis.',
        emailSentTo: 'Emailul a fost trimis către {{email}}.',
        retryIn: 'Poți încerca din nou în {{seconds}} secunde.',
        newShare: 'Creează un link nou',
        newShareHelp: 'Fiecare distribuire creează un link separat, reutilizabil de oricine îl primește.',
        duration: 'Durata accesului',
        days: 'zile',
        durationLimit: 'Minimum 1 zi, maximum 30 de zile. Valoarea implicită este 7 zile.',
        includeProblems: 'Permite accesul la problemele raportate de șofer',
        includeProblemsHelp: 'Linkul va include rapoartele și fotografiile existente și pe cele adăugate ulterior.',
        possessionWarning: 'Accesul este bazat pe posesia linkului, nu pe identitatea destinatarului.',
        creating: 'Se creează…',
        retryIssuance: 'Reîncearcă aceeași emitere',
        create: 'Creează link',
        latestShare: 'Link creat',
        validUntil: 'Valabil până la {{date}}',
        copyLink: 'Copiază linkul',
        sendEmail: 'Trimite pe email',
        emailTitle: 'Trimite linkul',
        emailHelp: 'Alege cui trimiți linkul, apoi personalizează mesajul dacă este nevoie.',
        chooseRecipient: 'Trimite emailul către',
        senderRecipient: 'Expeditorul transportului',
        consigneeRecipient: 'Destinatarul transportului',
        customRecipient: 'Altă adresă email',
        emailNotSet: 'Email nesetat',
        recipientEmail: 'Adresa email',
        fromName: 'Numele afișat ca expeditor',
        templateLanguage: 'Limba șablonului',
        applyTemplate: 'Aplică șablonul',
        subject: 'Subiect',
        message: 'Mesaj',
        sending: 'Se trimite…',
        send: 'Trimite emailul',
        existingShares: 'Linkuri existente',
        activeCount: '{{count}} active pe această pagină',
        independentHelp: 'Permisiunea pentru probleme și revocarea se aplică independent fiecărui link.',
        active: 'Activ',
        expired: 'Expirat',
        revokedStatus: 'Revocat',
        includeProblemsShort: 'Include problemele șoferului',
        savedPerShare: 'Setarea este salvată numai pentru acest link.',
        confirmRevoke: 'Confirmă revocarea',
        revoke: 'Revocă',
        noShares: 'Nu există linkuri create pentru acest transport.',
        previous: 'Anterior',
        page: 'Pagina {{page}} din {{total}}',
        next: 'Următor',
      },
      public: {
        accessErrorTitle: 'Acces indisponibil',
        accessErrorFallback: 'Linkul nu a putut fi validat. Încearcă din nou sau contactează expeditorul.',
        loadingTransport: 'Se încarcă informațiile transportului…',
        missingTransport: 'Detaliile transportului nu au putut fi încărcate pentru acest link.',
        readOnly: 'Doar vizualizare',
        customerReference: 'Referință client',
        headerHelp: 'Acest link oferă acces read-only doar la secțiunile aprobate de dispecer.',
        accessExpiry: 'Acces valabil până la',
        navigation: 'Secțiunile transportului',
        tabs: { overview: 'Sumar', stops: 'Opriri', cmrs: 'CMR-uri', documents: 'Documente', problems: 'Probleme raportate' },
        retryIn: 'Poți solicita din nou datele în {{seconds}} secunde.',
        loadingPlace: 'Loc încărcare',
        unloadingPlace: 'Loc descărcare',
        company: 'Companie',
        dispatcher: 'Dispecer',
        driver: 'Șofer',
        truck: 'Camion',
        trailer: 'Remorcă',
        startedAt: 'Început la',
        finishedAt: 'Finalizat la',
        refreshTitle: 'Date actualizate la cerere',
        refreshHelp: 'Pagina nu face polling automat. Reîncarcă manual pentru cele mai noi date.',
        sectionTitles: { stops: 'Opririle transportului', cmrs: 'Documente CMR structurate', documents: 'Fișiere disponibile', problems: 'Probleme raportate de șofer' },
        sectionHelp: {
          stops: 'Opririle sunt afișate în ordinea traseului.',
          cmrs: 'Sunt afișate numai câmpurile operaționale permise.',
          documents: 'Linkurile fișierelor au durată scurtă; reîncarcă secțiunea dacă expiră.',
          problems: 'Sunt afișate descrierea, contextul opririi și atașamentele permise de acest link.',
        },
        previous: 'Anterior',
        page: 'Pagina {{page}} din {{total}}',
        next: 'Următor',
        noResults: 'Nu există informații disponibile în această secțiune.',
        status: {
          unknown: 'Status nespecificat', neatribuit: 'Neatribuit', programat: 'Programat', scheduled: 'Programat',
          activ: 'Activ', active: 'Activ', in_curs: 'În curs', in_progress: 'În curs', finalizat: 'Finalizat',
          completed: 'Finalizat', anulat: 'Anulat', cancelled: 'Anulat', canceled: 'Anulat',
        },
        stopType: { unknown: 'Oprire', loading: 'Încărcare', unloading: 'Descărcare' },
        stopStatus: 'Status',
        stopStatusValue: {
          unknown: 'Nespecificat', pending: 'În așteptare', scheduled: 'Programată', arrived: 'Ajuns',
          in_progress: 'În desfășurare', completed: 'Finalizată', cancelled: 'Anulată', skipped: 'Omisă',
        },
        expectedAt: 'Data estimată',
        arrivedAt: 'Sosire',
        completedAt: 'Finalizare',
        cmr: 'CMR',
        cmrGroups: { identity: 'Identificare', sender: 'Expeditor', recipient: 'Destinatar', locations: 'Încărcare și livrare', cargo: 'Marfă', carrier: 'Transportator' },
        cmrFields: {
          cmr_number: 'Număr CMR', expeditor_nume: 'Nume expeditor', expeditor_adresa: 'Adresă expeditor', expeditor_tara: 'Țară expeditor',
          destinatar_nume: 'Nume destinatar', destinatar_adresa: 'Adresă destinatar', destinatar_tara: 'Țară destinatar',
          localitate_incarcare: 'Localitate încărcare', tara_incarcare: 'Țară încărcare', data_incarcare: 'Data încărcării',
          localitate_livrare: 'Localitate livrare', tara_livrare: 'Țară livrare', data_livrare: 'Data livrării',
          natura_marfii: 'Natura mărfii', marci_numere: 'Mărci și numere', numar_static: 'Număr statistic', mod_ambalare: 'Mod de ambalare',
          numar_colete: 'Număr colete', greutate_bruta: 'Greutate brută', cubaj: 'Cubaj',
          denumire_transportator: 'Denumire transportator', transportator: 'Transportator', adresa_transportator: 'Adresă transportator',
          tara_transportator: 'Țară transportator', marca_autovehicul: 'Marca autovehiculului', numar_circuaratie: 'Număr de înmatriculare',
        },
        documentKind: { document: 'Document', physical_cmr: 'CMR fizic', cmr: 'CMR', signed_cmr: 'CMR semnat' },
        openDocument: 'Deschide',
        driverProblem: 'Problemă raportată',
        reportedStatus: 'Status la raportare',
        photos: 'Fotografii',
        problemPhoto: 'Fotografie atașată problemei',
      },
      email: {
        subject: 'Acces la transportul {{reference}}',
        body: 'Ai primit acces pentru vizualizarea transportului {{reference}}. Deschide {{shareUrl}} sau folosește codul {{code}}. Accesul este valabil până la {{expiry}}.',
        problemsSuffix: 'Accesul include problemele raportate de șofer și atașamentele acestora, inclusiv raportările adăugate ulterior.',
      },
    },
    communications: {
      recipients: { expeditor: 'Expeditor', destinatar: 'Destinatar' },
      browserNotification: {
        newTitle: 'Notificare nouă',
        newBody: 'Ai primit o notificare nouă',
        systemTitle: 'Mesaj de sistem',
        driverStatusTitle: 'Status șofer',
      },
      signature: { closing: 'Cu stimă,' },
      supportMailto: {
        subject: 'Suport aplicație: {{subject}}',
        body: `Nume: {{name}}
Email: {{email}}
Subiect: {{subject}}

Mesaj:
{{message}}`,
      },
      accessCode: {
        subject: 'Cod de acces CMR — Transport #{{transportId}} — {{recipient}}',
        expirationFallback: 'data de expirare configurată',
        body: `🔐 COD DE ACCES CMR — Transport #{{transportId}}

Bună ziua,

Vă transmitem codul de acces pentru consultarea documentului CMR.

DETALII ACCES:
👤 Tip acces: {{recipient}}
🔐 COD DE ACCES: {{accessCode}}

INSTRUCȚIUNI DE UTILIZARE:
1. Deschideți linkul securizat: {{accessUrl}}
2. Codul va fi validat automat.

⚠️ IMPORTANT: Acest cod expiră la {{expiration}}.

Pentru asistență tehnică, vă rugăm să ne contactați.

{{signature}}`,
      },
      cmrDocument: {
        subject: 'CMR Transport #{{transportId}} — Document pentru {{recipient}}',
        body: `📋 DOCUMENT CMR — Transport #{{transportId}}

Bună ziua,

Vă transmitem documentul CMR pentru transportul organizat.

🚛 DETALII TRANSPORT:
📋 Cod transport: {{transportCode}}
🏢 Companie: {{company}}
🚛 Șofer: {{driver}}

📍 LOCAȚII:
📍 Loc preluare: {{pickupLocation}}
📍 Loc predare: {{deliveryLocation}}

🏢 EXPEDITOR:
🏢 Nume: {{senderName}}
📍 Adresă: {{senderAddress}}
🌍 Țară: {{senderCountry}}

🎯 DESTINATAR:
🏢 Nume: {{consigneeName}}
📍 Adresă: {{consigneeAddress}}
🌍 Țară: {{consigneeCountry}}

📦 INFORMAȚII MARFĂ:
📦 Natura mărfii: {{goodsDescription}}
⚖️ Greutate brută: {{grossWeight}} kg
📏 Volum: {{volume}} m³
📊 Nr. colete: {{packageCount}}

Vă rugăm să verificați documentul atașat și să ne contactați pentru orice clarificări.

🌐 Interfață AtruX: {{loginUrl}}

{{signature}}
📧 Email generat automat — nu răspundeți la acest mesaj`,
      },
      cmrPhoto: {
        subject: 'Fotografie CMR — Transport #{{transportId}} — Document pentru {{recipient}}',
        body: `📷 FOTOGRAFIE CMR — Transport #{{transportId}}

Bună ziua,

Vă transmitem fotografia documentului CMR pentru transportul organizat.

🚛 DETALII TRANSPORT:
📋 Cod transport: {{transportCode}}
🏢 Companie: {{company}}
🚛 Șofer: {{driver}}

📍 LOCAȚII:
📍 Loc preluare: {{pickupLocation}}
📍 Loc predare: {{deliveryLocation}}

🏢 EXPEDITOR:
🏢 Nume: {{senderName}}
📍 Adresă: {{senderAddress}}
🌍 Țară: {{senderCountry}}

🎯 DESTINATAR:
🏢 Nume: {{consigneeName}}
📍 Adresă: {{consigneeAddress}}
🌍 Țară: {{consigneeCountry}}

📷 Documentul atașat reprezintă fotografia CMR-ului fizic scanat/fotografiat.

Vă rugăm să verificați documentul atașat și să ne contactați pentru orice clarificări.

🌐 Interfață AtruX: {{loginUrl}}

{{signature}}
📧 Email generat automat — nu răspundeți la acest mesaj`,
      },
      feedback: {
        accessCodeSent: 'Codul de acces a fost trimis cu succes către {{recipient}}.',
        documentSent: 'Emailul a fost trimis cu succes către {{recipient}}.',
        photoSent: 'Fotografia CMR a fost trimisă cu succes către {{recipient}}.',
        invalidEmail: 'Adresa de email pentru {{recipient}} nu este validă. Introduceți o adresă validă.',
      },
      errors: {
        unknown: 'Eroare necunoscută la trimiterea emailului.',
        invalidData: 'Date invalide pentru trimiterea emailului.',
        unauthorized: 'Nu aveți autorizația necesară pentru această operațiune.',
        forbidden: 'Acces interzis la serviciul de email.',
        rateLimited: 'Prea multe încercări de trimitere. Încercați din nou mai târziu.',
        server: 'Eroare de server la trimiterea emailului. Încercați din nou.',
        connection: 'Eroare de conexiune. Verificați conexiunea la internet.',
        invalidResponse: 'Răspuns invalid de la server. Contactați administratorul.',
        accessCode: 'Eroare la trimiterea codului către {{recipient}}: {{detail}}',
        pdfGeneration: 'PDF-ul nu a putut fi generat. Încercați din nou.',
        pdfTooLarge: 'Fișierul PDF este prea mare pentru a fi trimis prin email.',
        document: 'Eroare la trimiterea emailului către {{recipient}}: {{detail}}',
        photoDownload: 'Fotografia CMR nu a putut fi descărcată. Încercați din nou.',
        photoUrlMissing: 'URL-ul fotografiei CMR lipsește.',
        photoTooLarge: 'Fotografia este prea mare pentru a fi trimisă prin email.',
        photo: 'Eroare la trimiterea fotografiei CMR către {{recipient}}: {{detail}}',
      },
    },
    esignature: {
      providerFallback: 'Furnizorul va comunica în {{language}}.',
      email: {
        defaultSubject: 'Semnare document CMR',
        defaultMessage: 'Vă rugăm să semnați documentul CMR anexat.',
      },
    },
  },
  en: {
    trackingMap: trackingMapCatalog.en,
    maintenance: maintenanceCatalog.en,
    common: {
      language: 'Language', retry: 'Try again', saving: 'Saving…',
      close: 'Close', delete: 'Delete', cancel: 'Cancel', save: 'Save', edit: 'Edit',
      reload: 'Reload', loading: 'Loading...', error: 'Error', notifications: 'Notifications',
      profile: 'Profile', support: 'Support', backToLogin: 'Back to login',
      nameUnavailable: 'Name unavailable', nameNotSpecified: 'Name not specified',
      notSpecified: 'Not specified', notAvailable: 'Not available',
      languageChangeFailed: 'The language could not be saved. The previous selection was restored.',
      calendar: {
        today: 'Today', previousMonth: 'Previous month', nextMonth: 'Next month',
        chooseDate: 'Choose date',
        chooseMonth: 'Choose a month. The displayed month is {{month}}.',
        chooseYear: 'Choose a year. The displayed year is {{year}}.',
      },
      pagination: {
        resultsRange_one: 'Showing {{start}}–{{end}} of {{total}} result',
        resultsRange_few: 'Showing {{start}}–{{end}} of {{total}} results',
        resultsRange_other: 'Showing {{start}}–{{end}} of {{total}} results',
        noResults: 'No results', firstPage: 'First page',
        previousPage: 'Previous page', nextPage: 'Next page', lastPage: 'Last page',
        page: 'Page {{page}}', itemsPerPage: 'Items per page:',
      },
      deleteConfirmation: {
        title: 'Confirm deletion',
        message: 'Are you sure you want to delete this item? This action cannot be undone.',
        itemPrompt: 'Are you sure you want to delete <item>“{{itemName}}”</item>?',
        irreversible: 'This action cannot be undone.',
        confirm: 'Yes, delete',
      },
      home: { goToHome: 'Go to the home page' },
      tenantConfiguration: {
        title: 'The company is not configured',
        description: 'Open the application using the subdomain provided by your company administrator.',
      },
      errorBoundary: {
        title: 'Something went wrong!',
        description: 'Sorry, an unexpected error occurred. Please reload the page.',
        reloadPage: 'Reload page',
      },
    },
    bootstrap: {
      loading: 'Loading available languages…', failed: 'We could not load the available languages.',
    },
    tachograph: {
      csv: {
        date: 'Date', startTime: 'Start time', endTime: 'End time',
        duration: 'Duration', activity: 'Activity',
        optifleetFileName: 'optifleet-tachograph-report-{{driverId}}-{{startDate}}-{{endDate}}.csv',
      },
      activities: {
        driving: 'Driving', rest: 'Rest', work: 'Other activities',
        available: 'Available', unknown: 'Unknown',
      },
    },
    transportDocuments: {
      title: 'Transport documents #{{transportId}}',
      available_one: '{{count}} document available',
      available_few: '{{count}} documents available',
      available_other: '{{count}} documents available',
      loading: 'Loading documents…',
      emptyTitle: 'No documents',
      emptyDescription: 'No documents have been uploaded for this transport.',
      view: 'View',
      viewDocument: 'View document',
      deleteDocument: 'Delete document',
      confirmDelete: 'Are you sure you want to delete this document?',
      deleteSuccess: 'Document deleted successfully!',
      loadError: 'Error loading documents.',
      deleteError: 'Error deleting the document.',
      categories: {
        cmr: 'CMR (photo)',
        thermogram: 'Thermogram',
        deliveryNote: 'Goods accompanying note',
        invoice: 'Invoice',
        customsDeclaration: 'Customs declaration',
        certificateOfOrigin: 'Certificate of origin',
        loadingList: 'Loading list',
        adrDocuments: 'ADR documents',
        otherDocuments: 'Other documents',
      },
    },
    transportCard: {
      customerOrder: 'Customer order',
    },
    transportCreation: {
      deliveryNotesSelected: '{{count}} delivery notes selected:',
      fromDeliveryNote: 'from delivery note:',
      addedManually: 'added manually',
      driverNumber: 'Driver #{{id}}',
    },
    tripSheets: {
      viewer: {
        openingTitle: 'Opening the trip sheet…',
        preparing: 'Preparing the document…',
      },
    },
    transportCrew: {
      driverNumber: 'Driver #{{id}}',
      driverPosition: 'Driver {{position}}:',
      noDriver: 'No driver',
      noDrivers: 'No drivers',
    },
    cmrStatus: {
      statuses: {
        complete: { label: '✅ Complete', tooltip: 'Has both a digital and a physical CMR' },
        digitalOnly: { label: '📝 Digital', tooltip: 'Has only a completed digital CMR' },
        physicalOnly: { label: '📄 Physical', tooltip: 'Has only physical CMRs (scanned)' },
        none: { label: '❌ Missing', tooltip: 'Has no CMR' },
      },
      digitalProgress: 'Digital: {{value}}',
      physicalDocuments_one: 'Physical: {{count}} document',
      physicalDocuments_few: 'Physical: {{count}} documents',
      physicalDocuments_other: 'Physical: {{count}} documents',
    },
    profitability: {
      roundTrip: { at: 'at', by: 'by' },
      dispatcherProjection: {
        notice: 'You are viewing the round-trip report without administration costs. Expenses and profit have already been calculated this way by the server; do not subtract administration again.',
        expensesLabel: 'Expenses without administration',
        profitLabel: 'Profit without administration',
        allocatedExpenses: 'Allocated expenses',
        completeTotals: 'Final calculation without administration for all displayed groups.',
        transportNotice: 'The displayed transport profit excludes administration.',
        serverProjection: 'The value has already been calculated by the server without administration costs.',
      },
      currencyConversion: {
        ready: 'Reference rates are available. Changing the currency automatically converts the amount.',
        readyDated: 'Reference rates for {{date}} are available. Changing the currency automatically converts the amount.',
        loading: 'Loading the latest available exchange rates…',
        loadError: 'Exchange rates could not be loaded. Conversion is disabled to prevent incorrect values.',
        convertedFrom: 'Converted from {{amount}}; subsequent changes use this value as the conversion basis.',
        conversionError: 'The amount was not converted because the original currency rate is missing. Correct the value manually.',
      },
      pdf: {
        title: 'Round-trip profitability report',
        truckFilter: 'Truck: {{value}}', driverFilter: 'Driver: {{value}}',
        exportedGroups_one: '{{count}} group exported',
        exportedGroups_few: '{{count}} groups exported',
        exportedGroups_other: '{{count}} groups exported',
        valuesInCurrency: 'values in {{currency}}', generatedAt: 'Generated: {{value}}',
        columns: {
          period: 'Period', route: 'Route', truck: 'Truck', driver: 'Driver',
          kilometres: 'Km', revenue: 'Revenue', fuel: 'Fuel', roadTolls: 'Tolls',
          perDiem: 'Per diem', receipts: 'Receipts', interventions: 'Service', other: 'Other',
          groupSalary: 'Group salary', truckFixedCost: 'Truck fixed cost',
          finalExpenses: 'Final expenses', finalProfit: 'Final profit',
        },
        summary: {
          revenue: 'Revenue', variableExpenses: 'Variable expenses',
          fixedCostsFullReportOnly: 'Fixed costs (full report only)',
          automaticFixedCosts: 'Automatic fixed costs',
          intermediateTripProfit: 'Trip profit (intermediate)',
          intermediateTableProfit: 'Table profit (intermediate)',
          finalCompanyNetProfit: 'Final company net profit',
        },
        tableTotal: 'Table total', automaticReport: 'Atrux · Automatically generated report',
        page: 'Page {{page}}/{{totalPages}}',
        fileName: 'round_trip_profitability_{{month}}{{suffix}}.pdf',
      },
    },
    leaveReports: {
      generatedBy: 'Leave Management System',
      annualPeriod: 'Year {{year}}',
    },
    fileNames: {
      signedDocument: 'signed-document-{{requestId}}.pdf',
      tripSheet: 'trip_sheet_{{date}}.pdf',
      cmrPhoto: 'CMR_Photo.jpg',
      optimizedRoute: 'optimized-route-{{date}}.json',
      interventionsReport: 'interventions_report_{{date}}.{{extension}}',
    },
    interventionReport: {
      title: 'Interventions Report',
      period: 'Period: {{start}} — {{end}}',
      totalInterventions: 'Total interventions: {{value}}',
      totalCost: 'Total cost: €{{value}}',
      topVehiclesByCost: 'Top vehicles by cost',
      interventions: 'Interventions',
      columns: {
        vehicle: 'Vehicle',
        type: 'Type',
        interventionCount: 'Interventions',
        totalCost: 'Total cost',
        reference: 'Reference',
        status: 'Status',
        entry: 'Entry',
      },
      types: {
        preventiveMaintenance: 'Preventive maintenance',
        repair: 'Repair',
        periodicRevision: 'Periodic inspection',
        accident: 'Accident',
      },
      statuses: {
        scheduled: 'Scheduled',
        inProgress: 'In progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
      vehicleTypes: {
        truck: 'Truck',
        trailer: 'Trailer',
        lightVehicle: 'Van',
      },
    },
    login: {
      welcome: 'Welcome!', subtitle: 'Sign in to continue!', phone: 'Phone number', password: 'Password',
      showPassword: 'Show password', hidePassword: 'Hide password', submit: 'SIGN IN', submitting: 'SIGNING IN',
      forgotPassword: 'Forgot your password? Reset it by email', alternateAccess: 'Or continue as:',
      expeditor: 'I am a freight forwarder', recipient: 'I am a recipient', signer: 'I am a general signer',
    },
    navigation: {
      dashboard: 'Dashboard', transports: 'Transports', liveTracking: 'GPS monitoring', drivers: 'Drivers', trucks: 'Trucks',
      trailers: 'Trailers', cars: 'Cars', vans: 'Vans', service: 'Service & Interventions', maintenance: 'Maintenance',
      cmr: 'CMR archive', uit: 'UIT e-Transport', freightBilling: 'Freight billing', billing: 'Billing', profitability: 'Profitability',
      profile: 'Profile', expiredDocuments: 'Expired documents',
      notifications: 'Notifications', toggleMenu: 'Open or close menu',
      collapseSidebar: 'Collapse sidebar', expandSidebar: 'Expand sidebar',
    },
    freightForwarding: {
      common: {
        transport: 'Transport', eligible: 'Eligible', notEligible: 'Not eligible',
        unknownAmount: 'Unknown amount', requestError: 'The operation could not be completed.', back: 'Back',
      },
      dashboard: {
        ready: 'Ready to invoice', documentsOverdue: 'Overdue documents', unpaid: 'Unpaid invoices', activeFiles: 'Active files',
      },
      filters: {
        month: 'Delivery month', customer: 'Customer', carrier: 'Carrier', responsible: 'Owner',
        idPlaceholder: 'User ID', searchPartner: 'Search partner…', transportStatus: 'Transport status', documentStatus: 'Document status', eligibility: 'Eligibility',
        documentsOverdue: 'Overdue documents', unpaid: 'Unpaid', minimumMargin: 'Minimum margin',
        all: 'All', yes: 'Yes', no: 'No', reset: 'Reset', apply: 'Apply filters',
      },
      queue: {
        eyebrow: 'Freight forwarding', title: 'Transport billing',
        subtitle: 'Review files and physical CMRs, then issue an individual invoice or group compatible transports.',
        readOnlyTitle: 'Issuing is unavailable.', readOnlyHint: 'You may review and complete files, but issuing requires the e-Invoice module.',
        search: 'Search by transport, customer or tax ID…', filters: 'Filters', loading: 'Loading billing files…',
        loadError: 'The transport billing queue could not be loaded.',
        emptyTitle: 'No transports match this selection', emptyHint: 'Change the filters or check again after a transport is completed.',
        customer: 'Customer', amount: 'Net amount', documents: 'File', payment: 'Payment', eligibility: 'Billing', actions: 'Actions',
        physicalCmrs_one: '{{count}} physical CMR', physicalCmrs_few: '{{count}} physical CMRs', physicalCmrs_other: '{{count}} physical CMRs',
        openFile: 'File', invoice: 'Invoice customer', notifyCustomer: 'Notify customer', selectAll: 'Select all visible transports',
        carrierReference: 'Carrier no.: {{reference}}',
        selectTransport: 'Select transport {{number}}', selected_one: '{{count}} transport selected', selected_few: '{{count}} transports selected', selected_other: '{{count}} transports selected',
        selectionReady: 'The selection is compatible with one shared invoice.', clear: 'Clear selection',
        invoiceSelected: 'Invoice selection', pageSummary: 'Page {{page}} of {{pages}} · {{count}} transports',
        directNotFound: 'This transport is not on the current queue page. Use the filters to find it.',
      },
      paymentNotice: {
        eyebrow: 'Customer notification', title: 'Send payment details',
        subtitle: 'Review the message for transport {{number}} before sending.',
        customer: 'Customer', amount: 'Amount', dueDate: 'Due date', loading: 'Loading the customer commercial details…',
        loadError: 'The payment details could not be loaded completely. You can complete the message manually.',
        email: 'Customer email', missingEmail: 'The customer has no saved email. Enter an address before sending.',
        subject: 'Subject', message: 'Message', invalidEmail: 'Enter a valid email address.',
        requiredFields: 'Subject and message are required.', send: 'Send notification', sending: 'Sending…',
        sent: 'The notification was sent to {{email}}.', sendError: 'The notification could not be sent.',
      },
      invoice: {
        eyebrow: 'Customer invoice', title_one: 'Invoice {{count}} transport', title_few: 'Invoice {{count}} transports', title_other: 'Invoice {{count}} transports',
        subtitle: 'A guided flow for customer documents, fiscal data and issue confirmation.', stepsLabel: 'Billing steps',
        stepDocuments: 'Documents', stepInvoice: 'Invoice', stepProgress: 'Progress',
        incompatibleTitle: 'The entire selection cannot be invoiced', physicalCmrTitle: 'Confirm the physical CMRs',
        physicalCmrHint: 'Select only approved photos or scans of the physical CMR. A generated eCMR is not a replacement.',
        loadingDocuments: 'Loading transport documents…', noPhysicalCmr: 'There is no physical CMR in the file yet.',
        selectPhysicalCmr: 'Select at least one physical CMR for this transport.',
        fiscalData: 'Invoice details', loadingFiscal: 'Loading series and VAT rates…', series: 'Series',
        issueDate: 'Issue date', dueDate: 'Due date', currency: 'Currency', vat: 'VAT rate', description: 'Service description',
        buyer: 'Customer details', buyerName: 'Legal name', buyerCui: 'Tax ID', country: 'Country', address: 'Address',
        sendEmail: 'Email the invoice to the customer after issue',
        sendEmailHint: 'The invoice remains issued if email delivery fails. Sending does not wait for SPV acceptance.',
        recipient: 'Recipient', emailLanguage: 'Email language', subject: 'Subject', message: 'Message',
        defaultLine: 'Transport services', defaultSubject: 'Transport invoice', defaultBody: 'The invoice and the related CMR are attached.',
        validation: {
          series: 'Select an invoice series.', issueDate: 'Choose the issue date.', buyer: 'Complete the customer name, country and address.',
          vat: 'Select a VAT rate.', amount: 'Every transport must have a positive net amount.', email: 'Enter a valid email address.',
        },
        efacturaRequired: 'Issuing requires access to the e-Invoice module.',
        confirmation: 'Confirmation creates an immutable draft and starts issuing. If the provider result is uncertain, check the state before cancelling or recreating it.',
        continue: 'Continue to invoice', issue: 'Issue invoice', issueAndEmail: 'Issue and email', submitting: 'Registering…',
        processingTitle: 'Issuing is in progress', processingHint: 'The request was accepted. The state updates automatically; closing this window will not duplicate the operation.',
        attentionTitle: 'A review is required', attentionHint: 'Do not recreate the invoice before reconciling the result.',
        issuedTitle: 'Invoice issued', issuedHint: 'Email status is tracked separately from fiscal issuing.',
        invoiceState: 'Invoice status', emailState: 'Email status', smtpHint: '“SMTP accepted” does not confirm delivery or reading.',
        pollError: 'The status could not be refreshed.', pollContinues: 'Automatic refresh will be retried.',
        emailFailedTitle: 'The invoice is issued, but email needs attention',
        emailFailedHint: 'Retrying sends only the email and does not issue another invoice.',
        uncertainConfirm: 'I checked the email system and confirmed the message was not already sent.', retryReason: 'Reason for resending',
        retryEmail: 'Retry email', draftPreserved: 'The existing draft was preserved; retrying will not create another invoice.',
      },
      workflow: {
        eyebrow: 'Freight file', subtitle: 'Documents, external access and audit in one place.',
        pageEyebrow: 'Transport file', carrierReference: 'Carrier transport no.',
        carrierUnknown: 'Carrier not specified', referenceUnknown: 'Not specified', back: 'Back', backToBilling: 'Back to billing',
        folderStatus: 'File status', billing: 'Billing', version: 'Version', documentCount: 'Documents', requirements: 'Required documents',
        addDocument: 'Add document', addDocumentHint: 'Choose the document type, then upload a photo, scan or PDF.', documentKind: 'Document type', optionalTitle: 'Optional title',
        chooseFile: 'Choose a PDF or image', fileHint: 'JPG, PNG, WEBP or PDF · up to 25 MiB', fileTooLarge: 'The file exceeds the 25 MiB limit.', upload: 'Upload document',
        documents: 'File documents', noDocuments: 'No documents have been uploaded.', reviewReason: 'Reason (required for rejection/archive)',
        originalDate: 'Original received date', reasonRequired: 'Enter a reason for rejection or archiving.',
        download: 'Download', accept: 'Accept', reject: 'Reject', archive: 'Archive', removeFromFile: 'Remove from file',
        untitledDocument: 'Untitled document', fileSource: 'Transport file',
        transportDocuments: 'Documents uploaded to the transport', transportDocumentsHint: 'This includes existing CMR photos or scans and files uploaded by a dispatcher or driver.',
        transportDocumentsUnavailable: 'The transport’s existing documents could not be loaded.', noTransportDocuments: 'No CMR photo or other transport document has been uploaded yet.',
        cmrPhotoSource: 'CMR photo / scan', transportDocumentSource: 'Transport document', openDocument: 'Open',
        uploadLink: 'Partner upload link', uploadLinkHint: 'The partner can upload documents without an account. Links expire after at most 30 days.',
        validity: 'Validity (days)', createLink: 'Create link', copy: 'Copy', copied: 'Copied', copyFailed: 'The link could not be copied.',
        openLink: 'Open', revoke: 'Revoke', history: 'History and comments', noHistory: 'There is no activity in this file yet.', commentPlaceholder: 'Add an internal comment…', addComment: 'Add comment',
      },
      publicUpload: {
        eyebrow: 'Secure upload', title: 'Transport documents', subtitle: 'Send the requested documents without creating an account.',
        checking: 'Checking the link…', missingToken: 'The link does not contain the required temporary code.',
        unavailableTitle: 'Link unavailable', unavailable: 'The link has expired, was revoked or is no longer available.',
        requestNew: 'Ask your contact person for a new link.', transport: 'Transport', expires: 'Expires',
        requestedDocuments: 'Requested documents', optional: 'optional', documentType: 'Document type', optionalTitle: 'Optional title',
        titlePlaceholder: 'For example: signed CMR', chooseFile: 'Choose a photo, scan or PDF',
        fileHint: 'JPG, PNG, WEBP or PDF · up to 25 MiB', fileTooLarge: 'The file exceeds the 25 MiB limit.',
        submit: 'Send document', uploading: 'Uploading…', uploadError: 'The document could not be uploaded.',
        successTitle: 'Document received', successHint: 'You may upload another document with this link while it remains valid.',
        privacy: 'The temporary code is used only for this upload. This page does not provide access to financial data or the company account.',
      },
      documentKinds: {
        cmr: 'Physical CMR', physical_cmr: 'Physical CMR', cmr_physical: 'Physical CMR', carrier_invoice: 'Carrier invoice',
        pod: 'Proof of delivery', customer_order: 'Customer order', order: 'Order', delivery_proof: 'Proof of delivery',
        delivery_note: 'Delivery note', customs: 'Customs document', temperature: 'Temperature', taxes: 'Taxes', photo: 'Photo', other: 'Other document',
      },
      states: {
        missing: 'Missing', partial: 'Partial', in_review: 'In review', rejected: 'Rejected', complete: 'Complete',
        accepted: 'Accepted', approved: 'Approved', verified: 'Verified', archived: 'Archived',
        draft: 'Draft', processing: 'Processing', issued: 'Issued', needs_attention: 'Needs attention', void: 'Void', reversed: 'Reversed',
        queued: 'Queued', waiting_invoice: 'Waiting for invoice', waiting_pdf: 'Waiting for PDF', sending: 'Sending', smtp_accepted: 'SMTP accepted', failed: 'Failed', cancelled: 'Cancelled',
        unknown: 'Unknown', unpaid: 'Unpaid', paid: 'Paid', finalizat: 'Completed', in_curs: 'In progress', intarziat: 'Delayed',
      },
    },
    billing: {
      eyebrow: 'Billing and e-Invoice', loading: 'Loading…', attention: 'Needs attention',
      draftNumber: 'Draft #{{id}}',
      statuses: {
        draft: 'Draft', ready_to_send: 'Ready to send', sending: 'Processing', sent: 'Processing', pending: 'Processing',
        not_sent: 'Not sent to SPV', accepted: 'Accepted', rejected: 'Rejected', failed: 'Failed',
        downloaded: 'Archive available', cancelling: 'Cancellation unconfirmed', cancelled: 'Cancelled',
      },
      submissionStatuses: {
        sending: 'Processing', sent: 'Processing', pending: 'Processing', not_sent: 'Not sent',
        accepted: 'Accepted', rejected: 'Rejected', failed: 'Failed', downloaded: 'Downloaded',
      },
      attachmentKinds: { anaf_zip: 'ANAF archive', receipt: 'Receipt', xml: 'XML', pdf: 'PDF', provider_response: 'Provider response', other: 'Document' },
      reference: {
        documentTypes: { fiscal: 'Fiscal invoice' }, clientTypes: { b2b: 'Company', b2c: 'Individual' },
        productTypes: { Serviciu: 'Service', Marfa: 'Goods' },
        countries: { RO: 'Romania', DE: 'Germany', FR: 'France', IT: 'Italy', ES: 'Spain', HU: 'Hungary', BG: 'Bulgaria', PL: 'Poland', NL: 'Netherlands', BE: 'Belgium', AT: 'Austria' },
        units: { H87: 'Item', KMT: 'Kilometre', HUR: 'Hour', DAY: 'Day', MON: 'Month', KGM: 'Kilogram', LTR: 'Litre' },
        vatKeys: { S: 'Standard VAT', E: 'Exempt', O: 'Outside VAT scope' },
      },
      actions: {
        back: 'Back', new: 'New invoice', open: 'Open', retry: 'Try again', cancel: 'Cancel', save: 'Save',
        saveDraft: 'Save draft', saving: 'Saving…', edit: 'Edit', validate: 'Validate',
        deletePermanently: 'Delete permanently', deletingPermanently: 'Deleting permanently…', previewDraft: 'Preview',
        markReady: 'Mark ready to send', issue: 'Issue invoice', issuing: 'Issuing…', send: 'Send to SPV', cancelInvoice: 'Cancel invoice',
        verifyCancellation: 'Verify cancellation', storno: 'Full reversal', createStorno: 'Create reversal',
        openPdf: 'View submitted PDF', downloadArchivedPdf: 'Download archived PDF', openExternalPdf: 'Open external PDF',
        reconcile: 'Resume reconciliation', requestArchive: 'Request archive', close: 'Close',
        refreshDocuments: 'Refresh documents', refresh: 'Refresh', download: 'Download', downloading: 'Downloading…', continue: 'Continue', processing: 'Processing…',
      },
      invoiceActions: {
        open: 'Invoice actions', edit: 'Edit invoice', collect: 'Collect invoice', storno: 'Reverse invoice',
        recurring: 'Convert to recurring invoice', cancel: 'Cancel invoice', copy: 'Copy invoice',
        units: 'Configure e-Invoice units', xml: 'Generate e-Invoice XML',
        notAvailableYet: 'This action still needs to be connected to the billing system.',
        editUnavailable: 'An issued invoice can no longer be edited.',
        stornoUnavailable: 'Available after the invoice is accepted in SPV.',
        cancelUnavailable: 'The current status does not allow cancellation.',
        copyUnavailable: 'A reversal draft cannot be copied as a standard invoice.',
        unitsUnavailable: 'Measurement units can only be changed on an editable draft.',
        xmlUnavailable: 'The XML becomes available after the invoice is accepted in SPV.',
        xmlQueued: 'The ANAF archive containing the XML was requested and will appear in the submission history.',
        xmlReady: 'The XML document or ANAF archive is available to download.',
      },
      actionReasons: {
        unavailable: 'This action is not available for the invoice’s current state.',
        requiresSync: 'The collection status will be checked before the operation.',
        billing_collections_not_enabled: 'Collections are not enabled for this company yet.',
        billing_collection_invalid_invoice: 'This invoice cannot accept a collection.',
        billing_collection_active_storno: 'An active reversal already exists for this invoice.',
        billing_collection_reconciliation_required: 'An uncertain collection must be reconciled first.',
        billing_operation_in_progress: 'Another operation is already in progress.',
        billing_invoice_has_collections: 'The invoice has collections. Correct them in the billing system and synchronize again.',
      },
      collections: {
        title: 'Invoice collections', description: 'Synchronize the balance and register payments confirmed by the billing provider.',
        status: 'Payment status', paid: 'Paid', remaining: 'Remaining', sync: 'Synchronize', synced: 'The collection status was updated.',
        lastSync: 'Last synchronization: {{date}}', neverSynced: 'The balance has not been verified yet.',
        staleTitle: 'Out-of-date data', staleDescription: 'Synchronization failed. The displayed values are the last known values and must not be read as a zero balance.',
        register: 'Register a collection', registerHint: 'This records a payment in {{currency}}; it does not initiate a bank transfer.',
        amount: 'Amount', issueDate: 'Collection date', method: 'Method', receiptSeries: 'Receipt series', documentNumber: 'Document number', mentions: 'Mentions',
        registerAction: 'Register', retrySame: 'Retry the same request', sameKeyRetry: 'The result may be uncertain. A retry keeps the same key and does not create a new payment.', conflict: 'The invoice state was reloaded and your input was preserved. Review the operation before trying again.',
        validation: 'Enter a positive amount and collection date.', futureDate: 'The collection date cannot be in the future.', receiptSeriesRequired: 'Enter the receipt series exactly as defined in the billing system.',
        confirmed: 'The collection was confirmed.', failed: 'The provider rejected the collection. No success message was shown.', uncertain: 'The result is uncertain and must be checked without resending the payment.',
        attentionTitle: 'Collection awaiting verification', attentionDescription: 'Use reconciliation to check the provider. Do not create a new intent for the same payment.',
        confirmedHistory: 'Confirmed collections', noCollections: 'There are no confirmed collections in the latest synchronization.', operations: 'Operation history', noOperations: 'There are no collection operations.', attempts: '{{count}} attempts',
        statuses: { unknown: 'Unknown', unpaid: 'Unpaid', partially_paid: 'Partially paid', paid: 'Paid', overpaid: 'Overpaid' },
        operationStatuses: { confirmed: 'Confirmed', failed: 'Failed', pending: 'Pending', needs_attention: 'Needs attention' },
        methods: {
          receipt: 'Receipt', fiscal_receipt: 'Fiscal receipt', fiscal_card_receipt: 'Fiscal card receipt', other_cash: 'Other cash payment', bank_transfer: 'Bank transfer', postal_order: 'Postal order', card: 'Card', cheque: 'Cheque', promissory_note: 'Promissory note', other_bank: 'Other bank payment', cash_on_delivery: 'Cash on delivery',
        },
      },
      copy: {
        title: 'Copy invoice', description: 'Create a new draft that is independent of the source invoice.', issueDate: 'Issue date (optional)', dueDate: 'Due date', customDueDate: 'Due date',
        dueModes: { preserve: 'Keep original interval', remove: 'No due date', custom: 'Choose date' }, create: 'Create copy', retrySame: 'Retry the same copy', validation: 'Choose the due date.',
        sameKeyRetry: 'The retry uses the same key and does not duplicate the invoice.', conflict: 'The source invoice changed. Your input was preserved; review it before copying again.',
      },
      recurrenceCreate: {
        title: 'Convert to recurring invoice', description: 'Create an independent template from this draft. Future invoices remain drafts and are not sent automatically.',
        name: 'Name', interval: 'Frequency', paymentTerm: 'Payment term', selectPaymentTerm: 'Select a payment term', firstDate: 'First date', endDate: 'End date (optional)',
        intervals: { 1: 'Monthly', 3: 'Every 3 months', 12: 'Yearly' }, create: 'Create recurrence', retrySame: 'Retry the same request', validation: 'Complete the name, first date and payment term. The first date cannot be in the past.', endDateValidation: 'The end date cannot precede the first occurrence.',
        scheduleHint: 'Generation starts after 08:00 Bucharest time and is checked periodically. Missed occurrences are recovered manually.', sameKeyRetry: 'The retry uses the same key and does not create a second template.', conflict: 'The source draft changed. The form was preserved; review it before continuing.',
      },
      recurrences: {
        open: 'Recurring invoices', title: 'Recurring invoices', description: 'Track templates, schedules and generated occurrences.', filter: 'Status', allStatuses: 'All statuses', emptyTitle: 'No recurrences', emptyDescription: 'Convert a draft from the Invoice actions menu.',
        loadError: 'Recurrences could not be loaded.', nextDate: 'Next date', everyMonths: 'Every {{count}} months', pagination: 'Page {{page}} of {{pages}} · {{count}} recurrences', statuses: { active: 'Active', paused: 'Paused', stopped: 'Stopped', completed: 'Completed' },
      },
      recurrenceDetail: {
        title: 'Recurrence details', description: 'Manage the template and manually recover missed occurrences.', schedule: 'Schedule', interval: 'Frequency', firstDate: 'First date', endDate: 'End date',
        scheduleHint: 'The initial schedule and frequency cannot be changed. Create a new recurrence for a different frequency.', settings: 'Template settings', saved: 'Recurrence settings were saved.', pause: 'Pause', resume: 'Resume', stop: 'Stop permanently', confirmStop: 'Permanently stop this recurrence?', pauseSuccess: 'The recurrence was paused.', resumeSuccess: 'The recurrence was resumed.', stopSuccess: 'The recurrence was stopped.',
        conflict: 'The recurrence changed in the meantime. Local input was preserved; review the updated version before saving.', occurrences: 'Occurrences', occurrencesHint: 'Generated and skipped occurrences are final. Only missed occurrences can be generated or skipped manually.', noOccurrences: 'There are no schedule occurrences.', openInvoice: 'Open draft', generate: 'Generate today', skip: 'Skip', generateOccurrenceSuccess: 'The draft for the missed occurrence was generated.', skipOccurrenceSuccess: 'The missed occurrence was skipped.', occurrenceStatuses: { scheduled: 'Scheduled', generated: 'Generated', skipped: 'Skipped', missed: 'Missed' },
      },
      pdfArchive: {
        title: 'Issued invoice PDF',
        available: 'The original PDF is securely archived and can be downloaded with authentication.',
        pending: 'The PDF is being retrieved and archived. Its availability is checked automatically.',
        failed: 'PDF archiving failed and requires review. The external PDF remains separately available, if present.',
        externalOnly: 'This invoice has no archived PDF. You can separately use the billing provider’s external link.',
        missing: 'The archived PDF is not available for this invoice.',
      },
      preview: {
        title: 'Customer preview', description: 'Check the draft layout and information before issuing it.',
        invoice: 'INVOICE', draftBadge: 'DRAFT', notIssued: 'No fiscal number', seller: 'Supplier', buyer: 'Customer',
        taxId: 'Tax ID', personalId: 'Personal ID', address: 'Address', registration: 'Trade register', iban: 'IBAN', bank: 'Bank', contact: 'Contact', issueDate: 'Issue date', dueDate: 'Due date', currency: 'Currency', status: 'Status',
        numberShort: 'No.', unitShort: 'U.M.', value: 'Value', preparedBy: 'Prepared by', signature: 'Recipient signature',
        descriptionColumn: 'Product / service', quantity: 'Quantity', unitPrice: 'Unit price', vat: 'VAT', total: 'Total',
        subtotal: 'Subtotal', vatTotal: 'VAT', grandTotal: 'Amount due', noLines: 'The draft does not have any lines yet.',
        disclaimer: 'This is a draft preview. The fiscal number and final PDF layout are established when the invoice is issued.',
      },
      paymentTerms: {
        title: 'Payment terms',
        description: 'Configure the options available when issuing invoices and choose the default term.',
        addTitle: 'Add payment term', add: 'Add', nameLabel: 'Name', namePlaceholder: 'E.g. Payment in 20 days',
        termLabel: 'Due-date calculation', calculationLabel: 'Calculation method', daysLabel: 'Number of days', daysPlaceholder: 'Days',
        defaultLabel: 'Default', actionsLabel: 'Actions', system: 'System term', custom: 'Custom term',
        protected: 'Protected', makeDefault: 'Set “{{name}}” as default', edit: 'Edit “{{name}}”',
        editNameLabel: 'Name for “{{name}}”', delete: 'Delete “{{name}}”',
        confirmDelete: 'Delete “{{name}}”? Existing invoices will not be changed.',
        loading: 'Loading payment terms…', empty: 'No payment terms are available.',
        daysValue: '{{count}} calendar days', created: 'The payment term was added.',
        updated: 'The payment term was updated.', defaultUpdated: 'The default payment term was updated.',
        deleted: 'The payment term was deleted.',
        calculation: {
          none: 'No payment term', issueDate: 'On the issue date', days: 'Number of days',
          endCurrentMonth: 'Last day of the current month', endNextMonth: 'Last day of the next month',
        },
        validation: { name: 'Enter a name of up to 100 characters.', days: 'Enter a whole number between 1 and 3650.' },
        errors: {
          title: 'The change was not saved', loadTitle: 'Payment terms could not be loaded',
          validation: 'Check the entered data and try again.', notFound: 'The term no longer exists. The list was reloaded.',
          nameExists: 'A payment term with this name already exists.', systemProtected: 'System terms cannot be changed or deleted.',
          limitReached: 'The limit of 100 payment terms has been reached.', permissionDenied: 'You do not have access to payment-term settings.',
          featureDisabled: 'The e-Invoice module is not enabled for this company.', unsupportedLanguage: 'The selected language is not supported.',
          unavailable: 'The service is temporarily unavailable. Try again.',
        },
      },
      bankAccounts: {
        open: 'Bank accounts', title: 'Bank accounts',
        description: 'Manage the company accounts. Linking them to invoices and PDFs is not available yet.',
        addTitle: 'Add a bank account', editTitle: 'Edit bank account', add: 'Add',
        nickname: 'Name', iban: 'IBAN', bankName: 'Bank', currency: 'Currency', noCurrency: 'No currency', actions: 'Actions',
        edit: 'Edit “{{name}}”', delete: 'Delete “{{name}}”', confirmDelete: 'Delete “{{name}}”?',
        created: 'The bank account was added.', updated: 'The bank account was updated.', deleted: 'The bank account was deleted.',
        loading: 'Loading bank accounts…', emptyTitle: 'No bank accounts',
        emptyDescription: 'Add the company’s first bank account.',
        pagination: 'Page {{page}} of {{pages}} · {{count}} accounts',
        validation: {
          nickname: 'Enter a name of up to 100 characters.', iban: 'Enter a valid IBAN.',
          bank_name: 'The bank name can contain up to 100 characters.', currency: 'Select an available currency.',
        },
        errors: {
          title: 'The change was not saved', loadTitle: 'Bank accounts could not be loaded',
          validation: 'Check the entered data and try again.', notFound: 'The account no longer exists. The list was reloaded.',
          ibanExists: 'This IBAN already exists.', nicknameExists: 'An account with this name already exists.',
          permissionDenied: 'You do not have access to bank account management.',
          featureDisabled: 'The e-Invoice module is not enabled for this company.',
          unsupportedLanguage: 'The selected language is not supported.', unavailable: 'The service is temporarily unavailable. Try again.',
        },
      },
      list: {
        title: 'Invoices', description: 'Create drafts, validate data, and track issuance and submission to SPV.',
        emptyTitle: 'No invoices', emptyDescription: 'Create the first draft. Saving it does not issue a fiscal document.',
        filteredEmptyTitle: 'No invoices in this interval', filteredEmptyDescription: 'Choose different dates or clear the filter to view all invoices.',
        filters: {
          from: 'From', to: 'To', apply: 'Filter', clear: 'Clear filter',
          hint: 'The interval includes both selected days and uses the invoice issue date.',
          invalid: 'Select both dates and make sure the start date is not after the end date.',
          active: 'Invoices issued between {{from}} and {{to}}',
        },
        columns: { invoice: 'Invoice', buyer: 'Buyer', issueDate: 'Issue date', total: 'Total', status: 'Status', action: 'Action' },
      },
      received: {
        open: 'Received invoices', issuedInvoices: 'Issued invoices', title: 'Invoices received through SPV',
        description: 'View e-Invoice messages received from suppliers and download the original XML archive or the PDF generated by ANAF.',
        loading: 'Loading received invoices…', downloading: 'Downloading ZIP…', downloadingPdf: 'Generating PDF…',
        downloadZip: 'Download ZIP', downloadPdf: 'Download PDF',
        metadataHint: 'The supplier name is identified automatically from its tax ID using the public ANAF registry.',
        downloadHint: 'The ZIP is the original SPV document. The PDF is generated on demand by the ANAF service and may be temporarily unavailable.',
        emptyTitle: 'No received invoices',
        emptyDescription: 'ANAF returned no received invoices for the selected interval.',
        companyCif: 'Buyer tax ID: {{cif}}', interval: 'Interval: {{start}} – {{end}}',
        historyLimitTitle: 'ANAF history is limited',
        historyLimit: 'The notification interval is no longer available in the 60-day window. The recent list was opened instead.',
        referenceExpiredTitle: 'The download reference expired',
        referenceExpired: 'The list is being reloaded to obtain a new reference. After it reloads, try the download again.',
        messageLabel: 'ANAF message {{id}}', supplierUnknown: 'Unknown supplier',
        filters: {
          startDate: 'From', endDate: 'To', apply: 'Show interval', recent: 'Last 30 days',
          hint: 'You can view at most the last 60 days. The next page reuses the exact interval returned by ANAF.',
        },
        columns: {
          receivedAt: 'ANAF date', details: 'Supplier', messageId: 'Message ID', uploadId: 'Upload ID', action: 'Downloads',
        },
        pagination: 'Page {{page}} of {{pages}} · {{count}} messages',
        errors: {
          invalidQueryTitle: 'Invalid interval', invalidQuery: 'The notification interval is incomplete, expired, or invalid. The recent list is shown.',
          invalidFilter: 'Choose a valid interval of at most 60 days whose end is not in the future.',
          rateLimitedTitle: 'Request limit reached', rateLimited: 'ANAF is temporarily limiting requests. Try again in {{seconds}}s.',
          notConfiguredTitle: 'Integration not configured', notConfigured: 'The operator must check the company tax ID and the securely configured ANAF token.',
          unauthorizedTitle: 'ANAF denied access', unauthorized: 'The operator must check the ANAF token and certificate rights for the company tax ID.',
          unavailableTitle: 'Received invoices are unavailable', unavailable: 'ANAF or a required service is temporarily unavailable. Try again later.',
          invalidArchiveTitle: 'The archive cannot be provided', invalidArchive: 'The ANAF archive failed the safety checks and was not downloaded.',
          pdfUnavailableTitle: 'The ANAF PDF is unavailable', pdfUnavailable: 'PDF conversion could not be completed right now. The original ZIP archive can still be downloaded separately.',
          notAcceptableTitle: 'Unsupported download format', notAcceptable: 'The requested format is not supported. Reload the page and try again.',
          featureDisabledTitle: 'The e-Invoice module is disabled', featureDisabled: 'The e-Invoice module is not enabled for this company.',
          accessDeniedTitle: 'Access denied', accessDenied: 'The current role cannot access received invoices.',
          sessionExpiredTitle: 'Invalid session', sessionExpired: 'Your session has expired or is no longer valid. Sign in again.',
        },
      },
      pagination: { summary: 'Page {{page}} of {{pages}} · {{count}} invoices', previous: 'Previous', next: 'Next' },
      configuration: {
        missingTitle: 'The company was not found in the billing system',
        missingDescription: 'Issuer tax ID: {{cif}}. You can save drafts, but ready/send actions remain blocked until setup is fixed.',
        draftAllowed: 'Issuer tax ID: {{cif}}. The draft can be saved; ready/send actions remain blocked.',
        unavailableTitle: 'The billing provider integration cannot be checked',
        unavailableDescription: 'The service is temporarily unavailable. Local data can still be kept in a draft.',
        blockActions: 'Ready and send actions are blocked until the company can be confirmed by the billing provider. This check does not confirm SPV setup.',
      },
      form: {
        createTitle: 'New invoice', editTitle: 'Edit draft', editStornoTitle: 'Edit reversal draft', copyTitle: 'Copy invoice',
        description: 'Complete the invoice data. Issuance happens only after validation, preparation, and sending.',
        copyDescription: 'Review the copied data and save it as a new draft before issuing it.',
        copyNoticeTitle: 'Data copied into a new invoice', copyNotice: 'The original invoice number and status are not copied. The new invoice is created only after you save it.',
        stornoEditDescription: 'Only the series and issue date can be edited on a reversal.',
        documentSection: 'Document', documentType: 'Document type', clientType: 'Client type', currency: 'Currency',
        series: 'Series', selectSeries: 'Select series', searchOptions: 'Search options...', seriesUnavailable: 'Series are currently unavailable; do not invent one.',
        issueDate: 'Issue date', dueDate: 'Due date', customDueDate: 'Custom due date', selectDate: 'Select date', buyerSection: 'Buyer',
        paymentTerms: {
          none: 'No payment term', issueDate: 'On the issue date', days: '{{count}} days',
          endOfCurrentMonth: 'Last day of the current month', endOfNextMonth: 'Last day of the next month', custom: 'Custom', configure: 'Configure',
        },
        buyerSnapshotHint: 'Enter the details of the customer receiving the invoice.',
        buyerCompanyHint: 'Enter the company tax ID to fill in its public details, then check them.',
        buyerLookup: {
          action: 'Find company', actionLoading: 'Searching…', loading: 'Searching the ANAF registry…',
          success: 'The public company details were filled in. Check them before continuing.',
          invalid: 'Enter a valid Romanian tax ID with 2–10 digits. The RO prefix is optional.',
          notFound: 'The company was not found in the ANAF registry. Enter its details manually.',
          unavailable: 'The ANAF registry is temporarily unavailable. You can enter the details manually.',
          accessDenied: 'You do not have access to company lookup. You can enter the details manually.',
          rateLimited: 'Too many searches. Try again in {{seconds}}s.',
          retry: 'You can try again or enter the details manually.',
          foreignCompany: 'For companies outside Romania, enter the details manually.',
        },
        buyerName: 'Name / company name', cui: 'Buyer tax ID', cnp: 'Personal ID (optional)', country: 'Country', address: 'Address',
        city: 'City', county: 'County', email: 'Email', phone: 'Phone', linesSection: 'Products and services',
        linesHint: 'Add the products or services you are billing. At least one is required to issue the invoice.',
        addLine: 'Add product or service', noLines: 'You have not added any products or services yet.', lineNumber: 'Product / service {{number}}',
        removeLine: 'Remove product or service', descriptionLabel: 'Description', quantity: 'Quantity', unit: 'Unit of measure', selectUnit: 'Select unit',
        unitPrice: 'Unit price', vat: 'VAT rate', selectVat: 'Select VAT pair', vatUnavailable: 'The billing provider VAT list is unavailable.',
        vatLoading: 'Loading the VAT list…', vatReload: 'Reload VAT list', vatReloading: 'Reloading VAT…',
        productType: 'Product type', ublUnit: 'Unit of measure', vatKey: 'VAT treatment', vatIncluded: 'VAT included in price',
        savedProduct: 'Saved product or service', savedProductHint: 'Choose a catalog item to fill in the line automatically.',
        selectSavedProduct: 'Choose from catalog', searchProducts: 'Search products or services...',
        saveProduct: 'Save for reuse on other invoices after issuing',
        errors: { required: 'Required field.', invalid_due_date: 'The due date cannot precede the issue date.', positive: 'Quantity must be positive.', nonnegative: 'Price cannot be negative.' },
      },
      lkwIssue: {
        title: 'Issue the invoice from extracted lines',
        description: '{{count}} active lines will be copied to the fiscal invoice in EUR.',
        loading: 'Loading issuance data…',
        linesTitle: 'Extracted line mapping',
        linesHint: 'All {{count}} active lines are included. Excluded lines will not be submitted.',
        vatForRate: 'VAT treatment for {{rate}}%',
        vatMissing: 'The billing provider does not offer this VAT rate.',
        confirmation: 'Continuing creates the fiscal invoice, validates it, and sends it to SPV. After a network error, check the invoice list before trying again.',
        issue: 'Issue and send to SPV',
        continueIssue: 'Continue issuance',
        invoiceHistoryUnavailable: 'Existing invoices could not be checked. Issuance is blocked to prevent a duplicate.',
        queued: 'The invoice was created and accepted for processing. Its PDF will be archived and shown here as soon as it is available.',
        created: 'e-Invoice #{{id}}',
        pdfReady: 'The issued PDF is available.',
        pdfPending: 'The invoice is processing; PDF availability is checked automatically.',
        polling: 'The invoice and PDF status are updated automatically…',
        openForDetails: 'Open the invoice for its full status and any corrections.',
        openInvoice: 'Open in e-Invoice',
        draftKept: 'The created e-Invoice draft was kept. Open it to make corrections before trying again.',
        validationTitle: 'The invoice cannot be issued yet',
        validation: {
          unsaved: 'Save the changes made to the header or extracted lines first.',
          series: 'Select a billing series.',
          issue_date: 'Enter the issue date.',
          due_date: 'The due date cannot precede the issue date.',
          buyer_cui: 'Enter the buyer tax ID.',
          buyer_name: 'Enter the buyer name.',
          buyer_address: 'Enter the buyer address.',
          buyer_country: 'Select the buyer country.',
          lines_empty: 'There are no active lines to invoice.',
          lines_limit: 'An invoice can contain at most 100 lines. Exclude lines or issue separate invoices.',
          line_description: 'Every line must have a description.',
          line_quantity: 'Quantities must be greater than zero.',
          line_quantity_precision: 'e-Invoice quantities can have no more than three decimal places.',
          line_unit: 'Every line must have a unit of measure.',
          line_price: 'Negative prices cannot be submitted on a standard fiscal invoice.',
          line_price_precision: 'e-Invoice unit prices can have no more than two decimal places.',
          line_vat: 'Select a valid VAT treatment for every extracted rate.',
        },
      },
      conflict: {
        title: 'The invoice changed in the meantime',
        description: 'Your edits remain local. The current server version is {{version}}; compare the data before continuing.',
        loadServer: 'Load server version',
        review: 'I reviewed the data',
      },
      detail: {
        title: 'Invoice details', summaryTitle: 'Invoice summary', summaryDescription: 'Check that the details below are correct before continuing.', version: 'Version {{version}}', saved: 'The draft was saved.',
        invoiceData: 'Invoice data', sellerSection: 'Issuing company', sellerName: 'Issuing company name', sellerCui: 'Issuing company tax ID', sellerAddress: 'Issuing company address', sellerCountry: 'Issuing company country', contact: 'Contact', missingValue: 'Missing', unknownValidationField: 'Required billing information', sellerValidationHint: 'Complete this information in the issuing company details.', seriesValidationHint: 'Select Edit and choose an invoice series.', buyerValidationHint: 'Select Edit and complete the buyer details.', linesValidationHint: 'Select Edit and correct the indicated product or service.', invoiceValidationHint: 'Select Edit and check the invoice details.', created: 'Created', stornoFor: 'Reversal for', openOriginalInvoice: 'Open original invoice', net: 'Net', vat: 'VAT', total: 'Total',
        validationErrors: 'Validation issues', valid: 'The invoice is valid', invalid: 'The invoice needs corrections',
        validDescription: 'The data passed validation. Marking it ready is a separate action.',
        invalidDescription: 'Correct the listed issues before marking the invoice ready.', readySuccess: 'The invoice is ready to send.',
        sendQueued: 'The operation was accepted for processing. This is not a fiscal acceptance confirmation.',
        anafProcessing: 'The invoice is being processed by ANAF. You will be notified when it is available in SPV.',
        pdfPending: 'The submitted PDF can be opened here as soon as it is generated.',
        cancelSuccess: 'The cancellation status was updated.', history: 'Submission history',
        historyHint: 'This is where you can follow what happens after the invoice is sent to SPV.', noSubmissions: 'There are no submissions yet.',
        submissionTitle: 'Submission to SPV', submissionDate: 'Started at {{date}}',
        submissionMeta: '{{phase}} · {{attempts}} attempts · {{date}}', attentionDescription: 'Automatic processing stopped. Inspect the operation before reconciliation.',
        noAttachments: 'No documents are available for this submission.', archiveQueued: 'Archive download was accepted for processing.',
        archiveAvailable: 'Available archive documents were refreshed.', reconcileQueued: 'Reconciliation was accepted for processing.',
      },
      storno: {
        title: 'Create full reversal', description: 'Explicitly choose whether the linked payment should be removed from the billing system. This is not proof of a bank transfer.',
        keepPayment: 'Keep the payment', keepPaymentHint: 'Sends refund_payment=false.',
        refundPayment: 'Remove the payment from the billing system', refundPaymentHint: 'Sends refund_payment=true to the provider.',
      },
      confirm: {
        cancel: 'Are you sure you want to cancel this invoice?',
        verifyCancellation: 'Check whether the uncertain cancellation was confirmed by the billing provider?',
        deleteInvoice: 'Permanently delete this invoice from AtruX? Documents in Oblio or SPV will not be deleted. This action cannot be undone.',
        deleteInvoiceWithAttachments: 'Permanently delete this invoice and its attached files from AtruX? Documents in Oblio or SPV will not be deleted. This action cannot be undone.',
      },
      errors: {
        loadList: 'Invoices could not be loaded.', loadInvoice: 'The invoice could not be loaded.',
        referenceData: 'General reference data could not be loaded.', series: 'Billing series could not be loaded.',
        vatRates: 'VAT rates could not be loaded.', products: 'Saved products and services could not be loaded.', partialResources: 'Some reference data is unavailable',
        save: 'The draft could not be saved.', action: 'The operation could not be completed.',
        uncertainCreate: 'The response was lost. Check the list before trying again to avoid creating a duplicate draft.',
        stateReloaded: 'The current state was reloaded before any possible retry.',
        invoiceUnavailable: 'The invoice is no longer available in the current company. The list was reloaded.',
        retryAfter: 'Try again in {{seconds}}s',
      },
    },
    expiredDocuments: {
      eyebrow: 'Document compliance',
      title: 'Expired documents',
      subtitle: 'Overdue items remain visible until a valid replacement is registered.',
      currentCount: 'Current overdue items',
      refresh: 'Reload status',
      tabs: { open: 'Unresolved', history: 'History', reports: 'Reports' },
      filters: {
        ownerType: 'Owner type', allOwners: 'All owners', ownerId: 'Owner ID',
        ownerIdPlaceholder: 'E.g. 42', category: 'Category', categoryPlaceholder: 'E.g. itp',
        from: 'Expiry from', to: 'Expiry to', reset: 'Reset', apply: 'Apply filters',
      },
      columns: { owner: 'Owner', document: 'Document', expiration: 'Expiry date', overdue: 'Overdue', resolution: 'Resolution', actions: 'Actions' },
      ownerTypes: { truck: 'Truck', trailer: 'Trailer', passenger_car: 'Car', van: 'Van', driver: 'Driver' },
      categories: {
        itp: 'Roadworthiness inspection', asigurare: 'Insurance', carte_identitate: 'Identity document',
        licenta_transport: 'Transport licence', tahograf: 'Tachograph', altele: 'Other',
        certificat_conformitate: 'Certificate of conformity', contract_asigurare: 'Insurance contract',
        asigurari_rca: 'Third-party liability insurance', inspectii_tehnice: 'Periodic technical inspections',
        carte_identitate_vehicul: 'Vehicle identity document', ec_certificat_conformitate: 'EC certificate of conformity',
        copie_conforma: 'Certified licence copy', procedura_instalare: 'Installation procedure', larm: 'LARM',
        rovigneta: 'Road vignette', rovinieta: 'Road vignette', rca: 'Third-party liability insurance', casco: 'Comprehensive insurance', civ: 'Vehicle identity document',
        certificat_inmatriculare: 'Registration certificate', buletin: 'Identity card',
        permis_de_conducere: 'Driving licence', atestate: 'Professional certificates', uncategorized: 'Uncategorised',
      },
      openStatus: 'Expired — new document not registered',
      resolved: 'Resolved',
      daysOverdue_one: '{{count}} day overdue', daysOverdue_few: '{{count}} days overdue', daysOverdue_other: '{{count}} days overdue',
      replacementExpiration: 'Replacement valid until',
      notResolved: 'Unresolved', untitled: 'Untitled document',
      imported: 'Period observed during import', openFolder: 'Open folder',
      historyFilter: 'Show', historyAll: 'All periods', historyResolved: 'Resolved only',
      pagination: 'Page {{page}} of {{pages}} · {{count}} results',
      paginationPage: 'Page',
      empty: {
        title: 'No results', description: 'No overdue items match the selected filters.',
        reportsTitle: 'No reports', reportsDescription: 'No report visible to you has been published yet.',
      },
      reports: {
        reportNumber: 'Report #{{id}}', published: 'Published', snapshot: 'Status at', back: 'Back to reports',
        immutable: 'This report preserves the snapshot saved when it was generated.',
      },
      replace: {
        action: 'Register replacement', eyebrow: 'Selected overdue item', title: 'Register replacement',
        documentTitle: 'New document title', expirationDate: 'New expiry date', issuingDate: 'Issue date',
        futureIssuingWarning: 'If the document takes effect in the future, the overdue item may remain open until then.',
        file: 'File (optional)', chooseFile: 'Choose a file', submit: 'Save replacement',
        success: 'The replacement was saved. The current status has been reloaded.',
        verifiedSuccess: 'The save was confirmed after checking the current status.',
        verifiedSavedStillOpen: 'The document was saved, but the overdue item is still open. Check its issue date and validity.',
      },
      errors: {
        load: 'The status could not be loaded.', reportUnavailable: 'The report does not exist or is no longer accessible.',
        invalidResolution: 'The overdue item changed or the replacement does not match. The status has been reloaded.',
        validation: 'Check the highlighted form values.', permission: 'You no longer have permission to register this replacement.',
        retryAfter: 'Too many requests. Try again in {{seconds}} seconds.',
        uncertainWrite: 'The connection was interrupted and the save could not be confirmed. The status was checked; do not resubmit before reloading again.',
        writeNotFound: 'The save does not appear in the reloaded status or folder. You can try again.',
        save: 'The replacement could not be saved.',
      },
      accessDeniedTitle: 'This section is unavailable',
      accessDeniedDescription: 'Your role or active modules do not allow access to the consolidated status.',
      notification: {
        expiringSoon: 'Expiring soon', expiresToday: 'Expires today', expired: 'Expired',
        report: 'Expired documents report', openReport: 'View report',
      },
      folder: { renewalRequired: 'Renewal required', overdueReplacement: 'Expired document — replacement required' },
    },
    roles: {
      fleetManager: 'Fleet Manager', driver: 'Driver', dispatcher: 'Dispatcher', economist: 'Economist', administrator: 'Administrator', user: 'User',
      guest: 'Not signed in',
    },
    dashboard: {
      welcome: 'Welcome,', generalStats: 'General statistics', active: 'Active',
      completed: 'Completed', activeDrivers: 'Active drivers', quickActions: 'Quick actions',
      quickActionsHelp: 'Quick access to the main workflows',
      adminActionsHelp: 'Quick access to administrative workflows',
      search: 'Search dashboard features', clearSearch: 'Clear search',
      noMatchingActions: 'No features match your search.', resetSearch: 'Reset search',
      helpTitle: 'Need help?',
      helpText: 'Contact the support team with any questions about the application or transports.',
      adminHelpText: 'Contact the support team with administration questions or technical issues.',
      adminHelpTitle: 'Administrator support',
      deleteTransportTitle: 'Confirm Transport Deletion',
      deleteTransportSuccess: 'Transport #{{id}} deleted successfully',
      deleteTransportError: 'Error deleting transport',
      statuses: {
        arrivedAtLoading: 'Arrived at loading', loadingStarted: 'Loading cargo',
        loadingEnded: 'Loading completed', arrivedAtUnloading: 'Arrived at unloading',
        unloadingStarted: 'Unloading', unloadingEnded: 'Unloading completed', delivered: 'Delivered',
        inTransit: 'In transit', assigned: 'Assigned', pending: 'Pending', unknown: 'Unknown',
      },
      actions: {
        gpsTracking: { title: 'GPS Tracking', description: 'Track simulated trucks and routes live on the map.' },
        trucks: { title: 'Trucks', description: 'View and manage the trucks in the fleet.', availableDescription: 'View all available trucks.' },
        trailers: { title: 'Trailers', description: 'View and edit active trailers.', availableDescription: 'View all available trailers.' },
        addTruck: { title: 'Add truck', description: 'Register a new truck in the fleet.', quickDescription: 'Quickly register a new truck.' },
        addTrailer: { title: 'Add trailer', description: 'Register a new trailer.' },
        transports: { title: 'Transports', description: 'View all transports currently in progress.' },
        createTransport: { title: 'Create transport', description: 'Add a new transport to the system.' },
        quotations: { title: 'Transport quotations', description: 'Calculate and save the recommended price for a dedicated transport.', adminDescription: 'Calculate and review recommended prices for dedicated transport.' },
        customers: { title: 'Freight-forwarding customers', description: 'View and add customers for brokered orders.' },
        carriers: { title: 'Subcontracted carriers', description: 'View external partners that perform transports.' },
        freightBilling: { title: 'Freight billing', description: 'Review files and CMRs, invoice individually or in bulk, and track issuing and email.', badge: 'Freight forwarding' },
        cmr: { title: 'CMR management', description: 'View and manage all CMR documents.' },
        uit: { title: 'UIT e-Transport', description: 'View vehicles and active UIT codes from ANAF.' },
        billing: { title: 'Billing', description: 'Create invoices and track their submission to SPV.' },
        receivedInvoices: { title: 'Invoices from SPV', description: 'View supplier invoices received through ANAF e-Invoice and download the XML archive.' },
        profitability: { title: 'Profitability', description: 'Monthly round-trip report, fixed costs, and dispatcher split.' },
        fuelExpenses: { title: 'Fuel expenses', description: 'Upload and review fuel invoices and road tolls.' },
        otherInvoices: { title: 'Monthly LKW WALTER invoices', description: 'Organise extractions by month and prepare the editable consolidated draft.' },
        drivers: { title: 'Drivers', description: 'Complete list of all registered drivers.' },
        observations: { title: 'Driver notes', description: 'Add and view notes by transport or driver.' },
        optifleet: { title: 'Optifleet tachograph data', description: 'Optifleet tachograph data for the selected period.' },
        addDriver: { title: 'Add driver', description: 'Add a new driver to the system.' },
        users: { title: 'Users', description: 'Manage drivers, dispatchers, and administrators.' },
        adminCmr: { title: 'CMR documents', description: 'View and filter all CMR documents.' },
        adminTransports: { title: 'Transports', description: 'View and manage all transports.' },
        adminDrivers: { title: 'Drivers', description: 'Manage all drivers in the system.' },
        adminCreateTransport: { title: 'Create transport', description: 'Create new transports in the system.' },
        expiredDocuments: { title: 'Expired documents', description: 'Track overdue documents until a replacement is registered.' },
      },
    },
    fleetDashboard: {
      loadError: 'Error loading dashboard data', loadErrorTitle: 'Fleet data could not be loaded',
      welcome: 'Welcome, {{name}}', assistance: 'Assistance', logout: 'Sign out', fleetState: 'Fleet status',
      attentionItems_one: '{{count}} item needs attention', attentionItems_few: '{{count}} items need attention', attentionItems_other: '{{count}} items need attention',
      vehiclesInMaintenance_one: '{{count}} vehicle in maintenance', vehiclesInMaintenance_few: '{{count}} vehicles in maintenance', vehiclesInMaintenance_other: '{{count}} vehicles in maintenance',
      expiringDocumentsCount_one: '{{count}} document is about to expire', expiringDocumentsCount_few: '{{count}} documents are about to expire', expiringDocumentsCount_other: '{{count}} documents are about to expire', checkDocuments: 'Check document validity',
      fleetHealthy: 'The fleet is in good condition', noUrgentItems: 'There are no urgent items', unspecifiedDate: 'Date not specified',
      overview: 'Overview', cardHint: 'Select a card for details', trucks: 'Trucks', trailers: 'Trailers',
      availableInUse: '{{available}} available · {{inUse}} in use', availableUsed: '{{available}} available · {{inUse}} in use',
      activeInterventions: 'Active service jobs', scheduledInProgress: '{{scheduled}} scheduled · {{inProgress}} in progress',
      expiringDocuments: 'Expiring documents', expiringDocumentsHelp: 'Documents approaching their expiry date',
      shortcuts: 'Shortcuts', whatNext: 'What would you like to do?',
      shortcutsHelp: 'The most frequently used operations are grouped here in a practical order.',
      actions: {
        scheduleIntervention: ['Schedule a service job', 'Open the service form directly'],
        serviceCalendar: ['View the service calendar', 'Upcoming service jobs and inspections'],
        manageTrucks: ['Manage trucks', 'Availability, details, and documents'],
        manageTrailers: ['Manage trailers', 'List, status, and documents'],
        manageCars: ['Manage cars', 'Records, details, and documents'],
        manageVans: ['Manage vans', 'Capacity, equipment, and documents'],
        allInterventions: ['All service jobs', 'Track work status'],
        fleetDocuments: ['Fleet documents', 'Validity and expiry dates'],
        expiredDocuments: ['Expired documents', 'Current overdue items, history, and reports'],
      },
      planning: 'Planning', upcomingInterventions: 'Upcoming service jobs', viewAll: 'View all',
      noScheduledInterventions: 'No service jobs scheduled', scheduleNow: 'Schedule now',
      compliance: 'Compliance', manage: 'Manage', documentsValid: 'All checked documents are valid.',
      expires: 'Expires', helpTitle: 'Need help?', helpText: 'Get support for fleet, documents, and service jobs.',
      contactSupport: 'Contact support', directSupport: 'Direct support', supportManager: 'Fleet Support Manager',
      callHelp: 'Call me with any request about fleet, documents, or service jobs.',
      directPhone: 'Direct phone', callNow: 'Call now',
    },
    app: {
      companyTemporarilyUnavailable: 'The company service is temporarily unavailable',
      companyUnavailable: 'The company is unavailable',
      retryLater: 'Try again in a few moments.',
      checkAddress: 'Check the address or contact the company administrator.',
      sessionExpired: 'Your session has expired or was revoked.',
      connectionError: 'Connection error',
    },
    profile: { languageTitle: 'Interface language', languageHelp: 'This preference is saved to your profile.' },
    apiErrors: {
      too_many_files: 'You can attach at most {{max_files}} files of this type.',
      file_too_large: 'The file exceeds the {{max_size_mib}} MiB limit.',
      batch_too_large: 'The selected files exceed the {{max_size_mib}} MiB total limit.',
      empty_file: 'The file is empty.',
      invalid_file_extension: 'The file extension is not supported.',
      file_mime_mismatch: 'The declared file type does not match its extension.',
      file_content_mismatch: 'The file content does not match its declared type.',
      invalid_file_structure: 'The file is damaged or does not have a valid structure.',
      invalid_filename: 'The filename is invalid.',
      unsupported_language: 'The selected language is not supported.',
      permission_denied: 'You do not have permission to perform this action.',
      authentication_failed: 'Authentication failed. Please sign in again.',
      validation_error: 'Some of the submitted data is invalid.',
      invalid_idempotency_key: 'The sharing safety key is invalid. Try issuing the share again.',
      invalid_share_expiry: 'The access period must be between 1 and 30 days.',
      tenant_conflict: 'This link does not belong to the open company. Use the exact link you received.',
      dispatcher_required: 'Only administrators and dispatchers can manage shares.',
      feature_not_enabled: 'Transport management is not enabled for this company.',
      efactura_anaf_invalid_query: 'The interval or page for received invoices is invalid.',
      efactura_anaf_invalid_reference: 'The download reference expired. The list will be reloaded.',
      efactura_anaf_rate_limited: 'There are too many ANAF requests. Wait before trying again.',
      efactura_anaf_not_configured: 'The received-invoice integration is not configured for this company.',
      efactura_anaf_unauthorized: 'ANAF denied access. The operator must check the token and certificate rights.',
      efactura_anaf_unavailable: 'The ANAF service is temporarily unavailable.',
      efactura_anaf_invalid_archive: 'The archive returned by ANAF failed the safety checks.',
      efactura_anaf_pdf_unavailable: 'ANAF PDF conversion is temporarily unavailable. You can separately download the original ZIP archive.',
      not_acceptable: 'The requested format is not accepted for this operation.',
      billing_request_too_large: 'The billing request exceeds the allowed limit.',
      billing_pdf_not_found: 'No archived PDF exists for this invoice.',
      billing_pdf_not_ready: 'The PDF is still being archived. Try again in a few moments.',
      billing_pdf_unavailable: 'The archived PDF is temporarily unavailable.',
      billing_pdf_rate_limited: 'There are too many PDF requests. Wait before trying again.',
      billing_collections_not_enabled: 'Collections are not enabled for this company.',
      billing_collection_invalid_invoice: 'This invoice cannot accept the collection.',
      billing_collection_active_storno: 'An active reversal blocks new collections.',
      billing_collection_exceeds_balance: 'The amount exceeds the invoice’s remaining balance.',
      billing_collection_invalid_receipt_series: 'The receipt series is not valid in the billing system.',
      billing_collection_reconciliation_required: 'An uncertain collection must be reconciled before a new operation.',
      billing_invoice_attachment_confirmation_required: 'This invoice has attached files. Its state was reloaded; review the warning and confirm permanent file deletion again.',
      billing_invoice_changed: 'The invoice changed in the meantime. Its current state was reloaded; review it and confirm again if you still want to delete it.',
      billing_invalid_invoice_status: 'The invoice status changed, and deletion is no longer available.',
      billing_reconciliation_required: 'Deletion is blocked by external history, an operation in progress, or unconfirmed file ownership. Check the invoice state before continuing.',
      freight_managed_invoice_immutable: 'This invoice is managed through its freight file. Use that file’s workflow to change or remove it.',
      billing_operation_in_progress: 'A billing operation is already in progress. Check its state before continuing.',
      billing_idempotency_key_required: 'The request needs its safety key. Retry the same operation.',
      billing_idempotency_conflict: 'The safety key belongs to different data. Review the operation before continuing.',
      billing_invoice_has_collections: 'The invoice has confirmed or uncertain collections. Correct them in the billing system and synchronize.',
      billing_copy_result_deleted: 'The draft previously created by this copy was deleted. Start a new copy after reviewing it.',
      problems_access_denied: 'Access to reported problems is no longer available through this link.',
      not_found: 'The requested resource is not available.',
      idempotency_content_conflict: 'This sharing attempt was changed. Start a new share instead.',
      share_unavailable: 'This access has expired, was revoked, or is no longer available.',
      rate_limited: 'Too many requests. Wait before trying again.',
      rate_limit_unavailable: 'Access-limit verification is temporarily unavailable. Try again.',
      service_unavailable: 'The service is temporarily unavailable. Try again.',
      invalid_share_code: 'The access link is invalid or no longer available.',
      maintenance_baseline_required: 'Complete the starting point or due value for every recurring interval.',
      maintenance_can_unavailable: 'A mileage plan requires a CargoTrack association and a valid CAN reading less than 24 hours old.',
      maintenance_calendar_interval_conflict: 'Choose either a day interval or a month interval.',
      maintenance_invalid_filter: 'One of the maintenance filters is invalid.',
      maintenance_object_already_associated: 'The CargoTrack object is already associated with another truck.',
      maintenance_service_already_exists: 'An active intervention already exists for this cycle.',
      maintenance_cycle_locked: 'The due value can no longer be changed after an intervention is scheduled or completed.',
      maintenance_completion_locked: 'The completion data for this intervention is protected.',
      maintenance_historical_service_use_source: 'Use the completed intervention as the source when creating the plan.',
      maintenance_intervention_delete_forbidden: 'This intervention belongs to maintenance history and cannot be deleted.',
      maintenance_sync_in_progress: 'A CargoTrack update is already in progress.',
      maintenance_refresh_throttled: 'Manual updates are limited. Wait before trying again.',
      maintenance_limiter_unavailable: 'Update-limit verification is temporarily unavailable.',
      maintenance_due_required: 'Complete at least one due value: mileage or date.',
      maintenance_interval_required: 'Recurring work requires an interval.',
      maintenance_type_required: 'Choose an active maintenance type.',
      request_failed: 'The request could not be completed.',
      field_required: 'This field is required.', invalid: 'This value is invalid.',
    },
    transportShare: {
      management: {
        action: 'Share with collaborators',
        eyebrow: 'External read-only access',
        title: 'Share with collaborators',
        subtitle: 'Manage links for transport',
        created: 'The access link was created.',
        visibilitySaved: 'Problem access was updated for this link.',
        revoked: 'The link was revoked.',
        alreadyUnavailable: 'The link was already unavailable and has been marked as revoked.',
        copied: 'The link was copied.',
        copyFailed: 'The link could not be copied. Select and copy it manually.',
        invalidEmail: 'Enter a valid email address.',
        emailFieldsRequired: 'Complete the sender, subject, and message.',
        emailSent: 'The email was sent.',
        emailSentTo: 'The email was sent to {{email}}.',
        retryIn: 'You can try again in {{seconds}} seconds.',
        newShare: 'Create a new link',
        newShareHelp: 'Each distribution creates a separate link that anyone who receives it can reuse.',
        duration: 'Access duration',
        days: 'days',
        durationLimit: 'Minimum 1 day, maximum 30 days. The default is 7 days.',
        includeProblems: 'Allow access to driver-reported problems',
        includeProblemsHelp: 'The link will include existing reports and photos and those added later.',
        possessionWarning: 'Access is based on possession of the link, not the recipient’s identity.',
        creating: 'Creating…',
        retryIssuance: 'Retry the same issuance',
        create: 'Create link',
        latestShare: 'Created link',
        validUntil: 'Valid until {{date}}',
        copyLink: 'Copy link',
        sendEmail: 'Send by email',
        emailTitle: 'Send the link',
        emailHelp: 'Choose who receives the link, then customize the message if needed.',
        chooseRecipient: 'Send the email to',
        senderRecipient: 'Transport sender',
        consigneeRecipient: 'Transport consignee',
        customRecipient: 'Another email address',
        emailNotSet: 'Email not set',
        recipientEmail: 'Email address',
        fromName: 'Displayed sender name',
        templateLanguage: 'Template language',
        applyTemplate: 'Apply template',
        subject: 'Subject',
        message: 'Message',
        sending: 'Sending…',
        send: 'Send email',
        existingShares: 'Existing links',
        activeCount: '{{count}} active on this page',
        independentHelp: 'Problem visibility and revocation apply independently to each link.',
        active: 'Active',
        expired: 'Expired',
        revokedStatus: 'Revoked',
        includeProblemsShort: 'Includes driver problems',
        savedPerShare: 'This setting is stored only for this link.',
        confirmRevoke: 'Confirm revoke',
        revoke: 'Revoke',
        noShares: 'No links have been created for this transport.',
        previous: 'Previous',
        page: 'Page {{page}} of {{total}}',
        next: 'Next',
      },
      public: {
        accessErrorTitle: 'Access unavailable',
        accessErrorFallback: 'The link could not be validated. Try again or contact the sender.',
        loadingTransport: 'Loading transport information…',
        missingTransport: 'Transport details could not be loaded for this link.',
        readOnly: 'View only',
        customerReference: 'Customer reference',
        headerHelp: 'This link provides read-only access only to sections approved by the dispatcher.',
        accessExpiry: 'Access valid until',
        navigation: 'Transport sections',
        tabs: { overview: 'Overview', stops: 'Stops', cmrs: 'CMRs', documents: 'Documents', problems: 'Reported problems' },
        retryIn: 'You can request the data again in {{seconds}} seconds.',
        loadingPlace: 'Loading place',
        unloadingPlace: 'Unloading place',
        company: 'Company',
        dispatcher: 'Dispatcher',
        driver: 'Driver',
        truck: 'Truck',
        trailer: 'Trailer',
        startedAt: 'Started at',
        finishedAt: 'Finished at',
        refreshTitle: 'Data refreshed on request',
        refreshHelp: 'The page does not poll automatically. Reload manually for the latest data.',
        sectionTitles: { stops: 'Transport stops', cmrs: 'Structured CMR documents', documents: 'Available files', problems: 'Driver-reported problems' },
        sectionHelp: {
          stops: 'Stops are displayed in route order.',
          cmrs: 'Only permitted operational fields are displayed.',
          documents: 'File links are short-lived; reload this section if one expires.',
          problems: 'Descriptions, stop context, and attachments permitted by this link are displayed.',
        },
        previous: 'Previous',
        page: 'Page {{page}} of {{total}}',
        next: 'Next',
        noResults: 'No information is available in this section.',
        status: {
          unknown: 'Status not specified', neatribuit: 'Unassigned', programat: 'Scheduled', scheduled: 'Scheduled',
          activ: 'Active', active: 'Active', in_curs: 'In progress', in_progress: 'In progress', finalizat: 'Completed',
          completed: 'Completed', anulat: 'Cancelled', cancelled: 'Cancelled', canceled: 'Cancelled',
        },
        stopType: { unknown: 'Stop', loading: 'Loading', unloading: 'Unloading' },
        stopStatus: 'Status',
        stopStatusValue: {
          unknown: 'Not specified', pending: 'Pending', scheduled: 'Scheduled', arrived: 'Arrived',
          in_progress: 'In progress', completed: 'Completed', cancelled: 'Cancelled', skipped: 'Skipped',
        },
        expectedAt: 'Expected at',
        arrivedAt: 'Arrival',
        completedAt: 'Completion',
        cmr: 'CMR',
        cmrGroups: { identity: 'Identification', sender: 'Sender', recipient: 'Consignee', locations: 'Loading and delivery', cargo: 'Cargo', carrier: 'Carrier' },
        cmrFields: {
          cmr_number: 'CMR number', expeditor_nume: 'Sender name', expeditor_adresa: 'Sender address', expeditor_tara: 'Sender country',
          destinatar_nume: 'Consignee name', destinatar_adresa: 'Consignee address', destinatar_tara: 'Consignee country',
          localitate_incarcare: 'Loading locality', tara_incarcare: 'Loading country', data_incarcare: 'Loading date',
          localitate_livrare: 'Delivery locality', tara_livrare: 'Delivery country', data_livrare: 'Delivery date',
          natura_marfii: 'Nature of goods', marci_numere: 'Marks and numbers', numar_static: 'Statistical number', mod_ambalare: 'Packaging method',
          numar_colete: 'Number of packages', greutate_bruta: 'Gross weight', cubaj: 'Volume',
          denumire_transportator: 'Carrier name', transportator: 'Carrier', adresa_transportator: 'Carrier address',
          tara_transportator: 'Carrier country', marca_autovehicul: 'Vehicle make', numar_circuaratie: 'Registration number',
        },
        documentKind: { document: 'Document', physical_cmr: 'Physical CMR', cmr: 'CMR', signed_cmr: 'Signed CMR' },
        openDocument: 'Open',
        driverProblem: 'Reported problem',
        reportedStatus: 'Status when reported',
        photos: 'Photos',
        problemPhoto: 'Photo attached to the problem',
      },
      email: {
        subject: 'Access to transport {{reference}}',
        body: 'You have been given access to view transport {{reference}}. Open {{shareUrl}} or use access code {{code}}. Access is valid until {{expiry}}.',
        problemsSuffix: 'Access includes driver-reported problems and their attachments, including reports added later.',
      },
    },
    communications: {
      recipients: { expeditor: 'Sender', destinatar: 'Consignee' },
      browserNotification: {
        newTitle: 'New notification',
        newBody: 'You have a new notification',
        systemTitle: 'System message',
        driverStatusTitle: 'Driver status',
      },
      signature: { closing: 'Kind regards,' },
      supportMailto: {
        subject: 'Application support: {{subject}}',
        body: `Name: {{name}}
Email: {{email}}
Subject: {{subject}}

Message:
{{message}}`,
      },
      accessCode: {
        subject: 'CMR access code — Transport #{{transportId}} — {{recipient}}',
        expirationFallback: 'the configured expiry date',
        body: `🔐 CMR ACCESS CODE — Transport #{{transportId}}

Hello,

We are sending you the access code for reviewing the CMR document.

ACCESS DETAILS:
👤 Access type: {{recipient}}
🔐 ACCESS CODE: {{accessCode}}

HOW TO USE:
1. Open the secure link: {{accessUrl}}
2. The code will be validated automatically.

⚠️ IMPORTANT: This code expires on {{expiration}}.

For technical assistance, please contact us.

{{signature}}`,
      },
      cmrDocument: {
        subject: 'CMR Transport #{{transportId}} — Document for {{recipient}}',
        body: `📋 CMR DOCUMENT — Transport #{{transportId}}

Hello,

Please find attached the CMR document for the arranged transport.

🚛 TRANSPORT DETAILS:
📋 Transport code: {{transportCode}}
🏢 Company: {{company}}
🚛 Driver: {{driver}}

📍 LOCATIONS:
📍 Pickup location: {{pickupLocation}}
📍 Delivery location: {{deliveryLocation}}

🏢 SENDER:
🏢 Name: {{senderName}}
📍 Address: {{senderAddress}}
🌍 Country: {{senderCountry}}

🎯 CONSIGNEE:
🏢 Name: {{consigneeName}}
📍 Address: {{consigneeAddress}}
🌍 Country: {{consigneeCountry}}

📦 CARGO DETAILS:
📦 Description of goods: {{goodsDescription}}
⚖️ Gross weight: {{grossWeight}} kg
📏 Volume: {{volume}} m³
📊 Number of packages: {{packageCount}}

Please review the attached document and contact us if you need any clarification.

🌐 AtruX interface: {{loginUrl}}

{{signature}}
📧 Automatically generated email — please do not reply`,
      },
      cmrPhoto: {
        subject: 'CMR photo — Transport #{{transportId}} — Document for {{recipient}}',
        body: `📷 CMR PHOTO — Transport #{{transportId}}

Hello,

Please find attached a photo of the CMR document for the arranged transport.

🚛 TRANSPORT DETAILS:
📋 Transport code: {{transportCode}}
🏢 Company: {{company}}
🚛 Driver: {{driver}}

📍 LOCATIONS:
📍 Pickup location: {{pickupLocation}}
📍 Delivery location: {{deliveryLocation}}

🏢 SENDER:
🏢 Name: {{senderName}}
📍 Address: {{senderAddress}}
🌍 Country: {{senderCountry}}

🎯 CONSIGNEE:
🏢 Name: {{consigneeName}}
📍 Address: {{consigneeAddress}}
🌍 Country: {{consigneeCountry}}

📷 The attachment is a scan or photo of the physical CMR document.

Please review the attached document and contact us if you need any clarification.

🌐 AtruX interface: {{loginUrl}}

{{signature}}
📧 Automatically generated email — please do not reply`,
      },
      feedback: {
        accessCodeSent: 'The access code was sent successfully to the {{recipient}}.',
        documentSent: 'The email was sent successfully to the {{recipient}}.',
        photoSent: 'The CMR photo was sent successfully to the {{recipient}}.',
        invalidEmail: 'The email address for the {{recipient}} is invalid. Enter a valid address.',
      },
      errors: {
        unknown: 'An unknown error occurred while sending the email.',
        invalidData: 'The email data is invalid.',
        unauthorized: 'You are not authorised to perform this operation.',
        forbidden: 'Access to the email service is forbidden.',
        rateLimited: 'Too many sending attempts. Try again later.',
        server: 'The email service encountered an error. Try again.',
        connection: 'Connection error. Check your internet connection.',
        invalidResponse: 'The server returned an invalid response. Contact the administrator.',
        accessCode: 'Error sending the code to the {{recipient}}: {{detail}}',
        pdfGeneration: 'The PDF could not be generated. Try again.',
        pdfTooLarge: 'The PDF file is too large to send by email.',
        document: 'Error sending the email to the {{recipient}}: {{detail}}',
        photoDownload: 'The CMR photo could not be downloaded. Try again.',
        photoUrlMissing: 'The CMR photo URL is missing.',
        photoTooLarge: 'The photo is too large to send by email.',
        photo: 'Error sending the CMR photo to the {{recipient}}: {{detail}}',
      },
    },
    esignature: {
      providerFallback: 'The provider will communicate in {{language}}.',
      email: {
        defaultSubject: 'Sign CMR document',
        defaultMessage: 'Please sign the attached CMR document.',
      },
    },
  },
};

// Keep the original catalog shape in a collision-free aggregate namespace
// while feature-specific namespaces are introduced incrementally. `app` is a
// real feature namespace, so it must not also be used for the aggregate bundle.
export const CATALOG_NAMESPACE = 'translation';

export const CATALOG_NAMESPACES = Object.freeze([
  CATALOG_NAMESPACE,
  ...Object.keys(catalogs.ro),
]);

export const catalogResources = Object.fromEntries(
  Object.entries(catalogs).map(([language, resources]) => [
    language,
    {
      // The aggregate namespace keeps pre-migration dotted keys working. Each
      // top-level domain is also exposed as a real feature namespace.
      [CATALOG_NAMESPACE]: resources,
      ...resources,
    },
  ]),
);

const nestedValue = (source, key) => key.split('.').reduce((value, part) => value?.[part], source);

export const translateFromCatalog = (language, key, params = {}) => {
  const template = nestedValue(catalogs[language], key) ?? nestedValue(catalogs.ro, key) ?? key;
  if (typeof template !== 'string') return key;
  return template.replace(/{{\s*([^}\s]+)\s*}}/g, (_, name) => String(params[name] ?? ''));
};
